'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var arIframes = document.querySelectorAll('iframe');

var _loop = function _loop(i) {
    var iframe = arIframes[i];
    if (!iframe.classList.contains('jsPreventIframeAspectRatio')) {
        var aspectRatio = getIframeAspectRatio(iframe);

        setIframeAspectRatio(iframe, aspectRatio);
        window.addEventListener('resize', function (_) {
            return setIframeAspectRatio(iframe, aspectRatio);
        });
    }
};

for (var i = 0; i < arIframes.length; i++) {
    _loop(i);
}

function setIframeAspectRatio(iFrameElement, ratio) {
    iFrameElement.style.height = Math.min(iFrameElement.offsetWidth / ratio[0] * ratio[1], window.innerHeight * 0.8) + 'px';
}

function getIframeAspectRatio(iframe) {
    var aspectRatio = iframe.dataset.aspectRatio;

    if (aspectRatio) {
        aspectRatio = aspectRatio.split(':');
    } else {
        var definedWidth = iframe.getAttribute('width');
        var definedHeight = iframe.getAttribute('height');

        aspectRatio = [1, definedHeight / definedWidth];
    }

    return aspectRatio;
}

/**
 * Do an AJAX request
 * @param parameters [{'key': 'value'}]
 * @param successCallback
 * @param errorCallback
 */
function se_postRequest(postUrl, parameters, successCallback, errorCallback) {
    var xmlHttp = new XMLHttpRequest();

    // Add the parameters
    var params = new FormData();
    var parameterKeys = Object.keys(parameters);

    for (var i = 0; i < parameterKeys.length; i++) {
        params.append(parameterKeys[i], parameters[parameterKeys[i]]);
    }xmlHttp.onreadystatechange = function () {
        if (xmlHttp.readyState === XMLHttpRequest.DONE) {
            if (xmlHttp.status === 200) {
                if (typeof successCallback !== 'undefined') successCallback(xmlHttp.responseText);
            } else {
                if (typeof errorCallback !== 'undefined') errorCallback();
            }
        }
    };

    xmlHttp.open('POST', postUrl, true);
    xmlHttp.send(params);
}

function ScrollDownButton(el) {
    el.addEventListener('click', function (e) {
        e.preventDefault();
        window.scrollTo({ top: window.innerHeight, behavior: 'smooth' });
    });
}

(function () {
    var scrollDownBtns = document.querySelectorAll('.jsScrollDownBtn');
    for (var i = 0; i < scrollDownBtns.length; i++) {
        new ScrollDownButton(scrollDownBtns[i]);
    }
})();

(function () {
    var scrollToTopBtn = document.querySelector('.jsScrollToTopBtn');
    if (scrollToTopBtn) {
        var setClassname = function setClassname() {
            if (window.scrollY > 800) {
                scrollToTopBtn.classList.add('visible');
                document.body.classList.add('scroll-to-top-visible');
            } else {
                scrollToTopBtn.classList.remove('visible');
                document.body.classList.remove('scroll-to-top-visible');
            }
        };

        setClassname();
        window.addEventListener('scroll', function (_) {
            return setClassname();
        });

        scrollToTopBtn.addEventListener('click', function (e) {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }
})();

function MainHeader(el) {
    this.el = el;

    this.initSlider();
    this.initVideo();
}

MainHeader.prototype.initSlider = function () {
    this.slider = this.el.querySelector('.jsMainHeaderSlider');

    if (this.slider) {
        new Flickity(this.slider, {
            contain: true,
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false,
            autoPlay: 4000,
            draggable: false,
            pauseAutoPlayOnHover: false
        });
    }
};

MainHeader.prototype.initVideo = function () {
    var _this = this;

    this.video = this.el.querySelector('.jsMainHeaderVideo');

    if (this.video) {
        this.setVideoDimensions();
        window.addEventListener('resize', function (_) {
            return _this.setVideoDimensions();
        });
    }
};

MainHeader.prototype.setVideoDimensions = function () {
    var width = this.el.offsetWidth;
    var height = width / 16 * 9;

    if (height < this.el.offsetHeight) {
        height = this.el.offsetHeight;
        width = height / 9 * 16;
    }

    this.video.style.width = width + 'px';
    this.video.style.height = height + 'px';
};

(function () {
    var mainHeader = document.querySelector('.jsMainHeader');
    if (mainHeader) new MainHeader(mainHeader);
})();

(function () {
    var menuEl = document.querySelector('.main-menu--main');
    if (!menuEl) return;

    var submenuIdCounter = 0;

    var isToggleOnlyHref = function isToggleOnlyHref(href) {
        if (!href) return true;
        var trimmed = href.trim();
        return trimmed === '' || trimmed === '#';
    };

    var getSubmenu = function getSubmenu(item) {
        return item.querySelector(':scope > .sub-menu, :scope > ul');
    };

    var ensureSubmenuId = function ensureSubmenuId(submenu) {
        if (!submenu) return null;
        if (!submenu.id) {
            submenuIdCounter += 1;
            submenu.id = 'main-submenu-' + submenuIdCounter;
        }
        return submenu.id;
    };

    var getLinkLabel = function getLinkLabel(link) {
        if (!link) return '';
        return (link.textContent || '').trim();
    };

    var getToggleLabel = function getToggleLabel(linkLabel, isOpen) {
        var name = linkLabel || 'submenu';
        return isOpen ? 'Submenu ' + name + ' sluiten' : 'Submenu ' + name + ' openen';
    };

    var setExpanded = function setExpanded(item, isOpen) {
        item.classList.toggle('is-open', isOpen);

        var link = item.querySelector(':scope > a');
        var linkLabel = getLinkLabel(link);
        var toggleBtn = item.querySelector(':scope > .main-menu__submenu-toggle');

        if (toggleBtn) {
            toggleBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            toggleBtn.setAttribute('aria-label', getToggleLabel(linkLabel, isOpen));
        }

        if (link && isToggleOnlyHref(link.getAttribute('href'))) {
            link.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        }
    };

    var closeItem = function closeItem(item) {
        setExpanded(item, false);

        [].concat(_toConsumableArray(item.querySelectorAll('.menu-item-has-children.is-open'))).forEach(function (child) {
            setExpanded(child, false);
        });
    };

    var closeAll = function closeAll() {
        [].concat(_toConsumableArray(menuEl.querySelectorAll('.menu-item-has-children.is-open'))).forEach(function (item) {
            setExpanded(item, false);
        });
    };

    var openItem = function openItem(item) {
        var parentList = item.parentElement;
        if (parentList) {
            [].concat(_toConsumableArray(parentList.children)).forEach(function (sibling) {
                if (sibling !== item && sibling.classList.contains('is-open')) closeItem(sibling);
            });
        }

        setExpanded(item, true);
    };

    var toggleItem = function toggleItem(item) {
        if (item.classList.contains('is-open')) closeItem(item);else openItem(item);
    };

    var focusTrigger = function focusTrigger(item) {
        var toggleBtn = item.querySelector(':scope > .main-menu__submenu-toggle');
        var link = item.querySelector(':scope > a');

        if (toggleBtn) toggleBtn.focus();else if (link) link.focus();
    };

    var getFirstSubmenuLink = function getFirstSubmenuLink(item) {
        var submenu = getSubmenu(item);
        if (!submenu) return null;
        return submenu.querySelector('a, button');
    };

    [].concat(_toConsumableArray(menuEl.querySelectorAll('li.menu-item-has-children'))).forEach(function (item) {
        if (item.closest('.main-menu__theme-switcher')) return;

        var link = item.querySelector(':scope > a');
        if (!link) return;

        var toggleOnly = isToggleOnlyHref(link.getAttribute('href'));
        var submenu = getSubmenu(item);
        var submenuId = ensureSubmenuId(submenu);
        var linkLabel = getLinkLabel(link);

        var toggleBtn = document.createElement('button');
        toggleBtn.type = 'button';
        toggleBtn.className = 'main-menu__submenu-toggle';
        toggleBtn.setAttribute('aria-expanded', 'false');
        toggleBtn.setAttribute('aria-haspopup', 'true');
        toggleBtn.setAttribute('aria-label', getToggleLabel(linkLabel, false));
        if (submenuId) toggleBtn.setAttribute('aria-controls', submenuId);

        link.after(toggleBtn);

        if (toggleOnly) {
            link.setAttribute('role', 'button');
            link.setAttribute('aria-expanded', 'false');
            link.setAttribute('aria-haspopup', 'true');
            if (submenuId) link.setAttribute('aria-controls', submenuId);

            link.addEventListener('click', function (e) {
                e.preventDefault();
                toggleItem(item);
            });

            link.addEventListener('keydown', function (e) {
                if (e.key !== 'Enter' && e.key !== ' ') return;
                e.preventDefault();
                toggleItem(item);
            });
        }

        toggleBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            toggleItem(item);
        });

        // ArrowDown opens and moves focus into the submenu
        var handleArrowDown = function handleArrowDown(e) {
            if (e.key !== 'ArrowDown') return;
            e.preventDefault();

            if (!item.classList.contains('is-open')) openItem(item);

            var firstLink = getFirstSubmenuLink(item);
            if (firstLink) firstLink.focus();
        };

        toggleBtn.addEventListener('keydown', handleArrowDown);
        if (toggleOnly) link.addEventListener('keydown', handleArrowDown);
    });

    document.addEventListener('click', function (e) {
        if (!menuEl.contains(e.target)) closeAll();
    });

    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;

        var openItems = [].concat(_toConsumableArray(menuEl.querySelectorAll('.menu-item-has-children.is-open')));
        if (!openItems.length) return;

        var focused = document.activeElement;
        var target = null;

        // Close the deepest open item that contains focus
        for (var i = openItems.length - 1; i >= 0; i--) {
            if (openItems[i].contains(focused)) {
                target = openItems[i];
                break;
            }
        }

        // Or close the deepest open item when focus is elsewhere in the menu
        if (!target && menuEl.contains(focused)) {
            target = openItems[openItems.length - 1];
        }

        if (!target) {
            closeAll();
            return;
        }

        closeItem(target);
        focusTrigger(target);
    });
})();

function SideMenu(el) {
    var _this2 = this;

    this.el = el;
    this.menuItemWrapper = this.el.querySelector('.jsSideMenuItems');
    this.rightEl = this.el.querySelector('.jsSideMenuRight');
    this.backBtn = this.rightEl.querySelector('.jsSideMenuBack');
    this.featuredEl = this.el.querySelector('.jsSideMenuFeatured');
    this.triggerEl = null;
    this.submenuIdCounter = 0;

    this.initTabs();
    this.initAccordions();
    this.initTopLevelTriggers();
    this.bindKeyboard();

    this.menuItemWrapper.addEventListener('click', function (e) {
        var menuItem = e.target.closest('.menu > .menu-item-has-children');
        if (!menuItem || !_this2.menuItemWrapper.contains(menuItem)) return;

        var link = menuItem.querySelector(':scope > a');
        if (!link || e.target !== link && !link.contains(e.target)) return;

        e.preventDefault();
        _this2.activateTab(menuItem.dataset.tabId);
    });

    this.tabWrapper.addEventListener('click', function (e) {
        var menuItem = e.target.closest('.tab__menu > .menu-item-has-children');
        if (!menuItem) return;

        // Don't intercept clicks on nested submenu links
        var nestedList = menuItem.querySelector(':scope > ul');
        if (nestedList && nestedList.contains(e.target)) return;

        e.preventDefault();
        _this2.toggleAccordion(menuItem);
    });

    this.el.addEventListener('click', function (e) {
        if (e.target.classList.contains('jsSideMenuClose')) {
            _this2.hide();
        }
    });

    this.backBtn.addEventListener('click', function (e) {
        e.preventDefault();

        _this2.rightEl.classList.remove('active');
        if (_this2.featuredEl) _this2.featuredEl.classList.remove('to-bottom');

        var activeTab = _this2.tabWrapper.querySelector('.tab.active');
        if (activeTab) {
            _this2.resetNestedOpenStates(activeTab);
            activeTab.classList.remove('active');
        }

        var openMenuItem = _this2.menuItemWrapper.querySelector('li.open');
        if (openMenuItem) {
            openMenuItem.classList.remove('open');
            _this2.setTopLevelExpanded(openMenuItem, false);
        }

        var firstTopLink = _this2.menuItemWrapper.querySelector('.menu > li > a');
        if (firstTopLink) firstTopLink.focus();
    });
};

SideMenu.prototype.getFocusableElements = function () {
    var _this3 = this;

    var selector = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var isMobile = window.matchMedia('(max-width: 479px)').matches;
    var rightActive = this.rightEl.classList.contains('active');

    return [].concat(_toConsumableArray(this.el.querySelectorAll(selector))).filter(function (el) {
        if (el.closest('[hidden], [aria-hidden="true"]')) return false;

        // On mobile the right panel slides over; keep focus in the visible panel
        if (isMobile) {
            if (rightActive && !_this3.rightEl.contains(el)) return false;
            if (!rightActive && _this3.rightEl.contains(el)) return false;
        }

        var tab = el.closest('.tabs .tab');
        if (tab && !tab.classList.contains('active')) return false;

        var accordion = el.closest('.tab__menu > .menu-item-has-children');
        if (accordion) {
            var nestedList = accordion.querySelector(':scope > ul');
            if (nestedList && nestedList.contains(el) && !accordion.classList.contains('open')) {
                return false;
            }
        }

        var style = window.getComputedStyle(el);
        if (style.display === 'none' || style.visibility === 'hidden') return false;

        return el.getClientRects().length > 0;
    });
};

SideMenu.prototype.bindKeyboard = function () {
    var _this4 = this;

    this.el.addEventListener('keydown', function (e) {
        if (!document.body.classList.contains('side-menu-open')) return;

        if (e.key === 'Escape') {
            e.preventDefault();

            // Close open accordion first, then right panel, then the menu
            var openAccordion = _this4.tabWrapper.querySelector('.tab.active .tab__menu > .menu-item-has-children.open');
            if (openAccordion) {
                _this4.toggleAccordion(openAccordion, false);
                var link = openAccordion.querySelector(':scope > a');
                if (link) link.focus();
                return;
            }

            if (_this4.rightEl.classList.contains('active') && window.matchMedia('(max-width: 479px)').matches) {
                _this4.backBtn.click();
                return;
            }

            _this4.hide();
            return;
        }

        if (e.key !== 'Tab') return;

        var focusables = _this4.getFocusableElements();
        if (focusables.length < 2) return;

        var first = focusables[0];
        var last = focusables[focusables.length - 1];

        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    });
};

SideMenu.prototype.setTopLevelExpanded = function (menuItem, isOpen) {
    var link = menuItem.querySelector(':scope > a');
    if (!link) return;
    link.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
};

SideMenu.prototype.initTopLevelTriggers = function () {
    var _this5 = this;

    [].concat(_toConsumableArray(this.menuItemWrapper.querySelectorAll('.menu > .menu-item-has-children'))).forEach(function (item) {
        var link = item.querySelector(':scope > a');
        if (!link) return;

        link.setAttribute('aria-expanded', 'false');
        link.setAttribute('aria-haspopup', 'true');

        link.addEventListener('keydown', function (e) {
            if (e.key !== 'Enter' && e.key !== ' ') return;
            e.preventDefault();
            _this5.activateTab(item.dataset.tabId);
        });
    });
};

SideMenu.prototype.initAccordions = function () {
    var _this6 = this;

    [].concat(_toConsumableArray(this.tabWrapper.querySelectorAll('.tab__menu > .menu-item-has-children'))).forEach(function (item) {
        var link = item.querySelector(':scope > a');
        var submenu = item.querySelector(':scope > ul');
        if (!link || !submenu) return;

        _this6.submenuIdCounter += 1;
        if (!submenu.id) submenu.id = 'side-submenu-' + _this6.submenuIdCounter;

        link.setAttribute('role', 'button');
        link.setAttribute('aria-expanded', 'false');
        link.setAttribute('aria-haspopup', 'true');
        link.setAttribute('aria-controls', submenu.id);

        link.addEventListener('keydown', function (e) {
            if (e.key !== 'Enter' && e.key !== ' ') return;
            e.preventDefault();
            _this6.toggleAccordion(item);
        });
    });
};

SideMenu.prototype.toggleAccordion = function (menuItem, forceOpen) {
    var wasOpen = menuItem.classList.contains('open');
    var shouldOpen = typeof forceOpen === 'boolean' ? forceOpen : !wasOpen;

    this.resetNestedOpenStates(menuItem.closest('.tab__menu'));

    if (shouldOpen) menuItem.classList.add('open');

    var link = menuItem.querySelector(':scope > a');
    if (link) link.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
};

SideMenu.prototype.show = function (triggerEl) {
    var _this7 = this;

    this.triggerEl = triggerEl || document.activeElement;
    document.body.classList.add('side-menu-open');
    this.el.setAttribute('aria-hidden', 'false');

    if (this.triggerEl && this.triggerEl.setAttribute) {
        this.triggerEl.setAttribute('aria-expanded', 'true');
    }

    gsap.timeline().set(this.el, { opacity: 0 }).add(function (_) {
        return _this7.el.classList.add('visible');
    }).to(this.el, 0.5, { opacity: 1, ease: 'power2.inOut' }).add(function (_) {
        var closeBtn = _this7.el.querySelector('.jsSideMenuClose');
        if (closeBtn) closeBtn.focus();
    });
};

SideMenu.prototype.hide = function () {
    var _this8 = this;

    gsap.timeline().to(this.el, 0.5, { opacity: 0, ease: 'power2.inOut' }).add(function (_) {
        _this8.rightEl.classList.remove('active');
        if (_this8.featuredEl) _this8.featuredEl.classList.remove('to-bottom');

        _this8.el.classList.remove('visible');
        _this8.el.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('side-menu-open');

        var activeTab = _this8.tabWrapper.querySelector('.tab.active');
        if (activeTab) {
            _this8.resetNestedOpenStates(activeTab);
            activeTab.classList.remove('active');
        }

        var openMenuItem = _this8.menuItemWrapper.querySelector('li.open');
        if (openMenuItem) {
            openMenuItem.classList.remove('open');
            _this8.setTopLevelExpanded(openMenuItem, false);
        }

        if (_this8.triggerEl && _this8.triggerEl.setAttribute) {
            _this8.triggerEl.setAttribute('aria-expanded', 'false');
        }

        if (_this8.triggerEl && typeof _this8.triggerEl.focus === 'function') {
            _this8.triggerEl.focus();
        }

        _this8.triggerEl = null;
    });
};

SideMenu.prototype.initTabs = function () {
    this.tabWrapper = this.el.querySelector('.jsTabs');
};

SideMenu.prototype.resetNestedOpenStates = function (scope) {
    if (!scope) return;
    [].concat(_toConsumableArray(scope.querySelectorAll('.tab__menu > .menu-item-has-children'))).forEach(function (item) {
        item.classList.remove('open');
        var link = item.querySelector(':scope > a');
        if (link) link.setAttribute('aria-expanded', 'false');
    });
};

SideMenu.prototype.activateTab = function (tabId) {
    this.rightEl.classList.add('active');
    if (this.featuredEl) this.featuredEl.classList.add('to-bottom');

    var activeTab = this.tabWrapper.querySelector('.tab.active');
    if (activeTab) {
        this.resetNestedOpenStates(activeTab);
        activeTab.classList.remove('active');
    }

    var nextActiveTab = this.tabWrapper.querySelector('.tab[data-tab-id="' + tabId + '"]');
    if (nextActiveTab) {
        this.resetNestedOpenStates(nextActiveTab);
        nextActiveTab.classList.add('active');
    }

    var openMenuItem = this.menuItemWrapper.querySelector('li.open');
    if (openMenuItem) {
        openMenuItem.classList.remove('open');
        this.setTopLevelExpanded(openMenuItem, false);
    }

    var nextOpenMenuItem = this.menuItemWrapper.querySelector('li[data-tab-id="' + tabId + '"]');
    if (nextOpenMenuItem) {
        nextOpenMenuItem.classList.add('open');
        this.setTopLevelExpanded(nextOpenMenuItem, true);
    }

    // Move focus into the opened panel
    var focusTarget = this.backBtn.offsetParent !== null ? this.backBtn : nextActiveTab && nextActiveTab.querySelector('a, button');

    if (focusTarget) focusTarget.focus();
};

(function () {
    var sideMenuEl = document.querySelector('.jsSideMenu');
    if (sideMenuEl) {
        var sideMenu = new SideMenu(sideMenuEl);
        sideMenuEl.setAttribute('aria-hidden', 'true');

        document.body.addEventListener('click', function (e) {
            var trigger = e.target.closest('.jsShowSideMenuTrigger');
            if (!trigger) return;

            e.preventDefault();
            sideMenu.show(trigger);
        });
    }
})();

function ProgressIndicator(el) {
    var _this9 = this;

    this.el = el;

    this.updateProgress();
    window.addEventListener('scroll', function (_) {
        return _this9.updateProgress();
    });
}

ProgressIndicator.prototype.updateProgress = function () {
    var percentage = window.scrollY / (document.body.offsetHeight - window.innerHeight) * 100;

    if (percentage > 100) percentage = 100;else if (percentage < 0) percentage = 0;

    gsap.to(this.el, 0.3, { width: percentage + '%', ease: Power2.easeOut });
};

(function () {
    var progressIndicatorEl = document.querySelector('.jsProgressIndicator');
    if (progressIndicatorEl) new ProgressIndicator(progressIndicatorEl);
})();

function SeSelect(el, urlParam) {
    var _this10 = this;

    this.el = el;
    this.urlParam = urlParam;
    this.activeOptions = {};
    this.changeEventListeners = [];
    this.selectToggleEl = this.el.querySelector('.jsSeSelectToggle');
    this.initialTitle = this.selectToggleEl.innerHTML;

    this.el.addEventListener('click', function (e) {
        if (e.target.classList.contains('jsSeSelectToggle')) {
            _this10.toggle();
        }
    });

    this.el.addEventListener('change', function (e) {
        if (e.target.checked) _this10.setActiveOption(e.target.value, e.target.dataset.name);else _this10.removeActiveOption(e.target.value, e.target.dataset.name);

        _this10.hide();
    });
}

SeSelect.prototype.toggle = function () {
    this.el.classList.toggle('open');
};

SeSelect.prototype.hide = function () {
    this.el.classList.remove('open');
};

SeSelect.prototype.setActiveOptions = function (optionKeys) {
    for (var i = 0; i < optionKeys.length; i++) {
        var optionEl = this.el.querySelector('input[value="' + optionKeys[i] + '"]');
        if (optionEl) this.setActiveOption(optionKeys[i], optionEl.dataset.name);
    }
};

SeSelect.prototype.setActiveOption = function (key, value) {
    if (typeof this.activeOptions[key] === 'undefined') {
        this.activeOptions[key] = value;

        this.updateUrl();
        this.callChangeEventListeners();
        this.setSelectLabel();
        this.el.querySelector('input[value="' + key + '"]').checked = true;
    }
};

SeSelect.prototype.removeActiveOption = function (key, value) {
    if (typeof this.activeOptions[key] !== 'undefined') {
        delete this.activeOptions[key];

        this.updateUrl();
        this.callChangeEventListeners();
        this.setSelectLabel();
    }
};

SeSelect.prototype.callChangeEventListeners = function () {
    for (var i = 0; i < this.changeEventListeners.length; i++) {
        this.changeEventListeners[i](this.activeOptions);
    }
};

SeSelect.prototype.addChangeEventListener = function (listener) {
    this.changeEventListeners.push(listener);
};

SeSelect.prototype.updateUrl = function () {
    var url = new Url();
    var values = Object.keys(this.activeOptions);

    if (values.length > 0) url.query[this.urlParam] = values.join(',');else delete url.query[this.urlParam];

    history.pushState(null, null, url.toString());
};

SeSelect.prototype.setSelectLabel = function () {
    var activeValues = Object.values(this.activeOptions);

    if (activeValues.length > 0) {
        this.selectToggleEl.innerHTML = activeValues.join(', ');
        this.el.classList.add('is-active');
    } else {
        this.selectToggleEl.innerHTML = this.initialTitle;
        this.el.classList.remove('is-active');
    }
};

(function () {
    var contactMapEl = document.querySelector('.jsContactMap');
    var mapZoom = 15;

    if (contactMapEl) {
        if (googleMapsApiIsLoaded) initMap();else window.addEventListener('se-gm-api-loaded', function (_) {
            return initMap();
        });
    }

    function initMap() {
        // Init the map
        var map = new google.maps.Map(contactMapEl, {
            center: mapsLocation,
            zoom: mapZoom,
            disableDefaultUI: true,
            zoomControl: true,
            scrollwheel: false
        });

        // On resize, center the map
        window.addEventListener('resize', function (_) {
            map.setCenter(mapsLocation);
            map.setZoom(mapZoom);
        });

        // Add the marker to the map
        new google.maps.Marker({
            position: mapsLocation,
            map: map,
            icon: { url: mapsIcon, scaledSize: new google.maps.Size(94, 94) }
        });
    }
})();

function SearchMenu(el) {
    var _this11 = this;

    this.el = el;

    this.el.addEventListener('click', function (e) {
        if (e.target.classList.contains('jsSearchMenuClose')) {
            e.preventDefault();
            _this11.hide();
        }
    });

    this.el.addEventListener('submit', function (e) {
        e.preventDefault();

        var inputValue = e.target.querySelector('input').value;
        var postType = e.target.querySelector('select').value;
        var urlSuffix = '/?s=' + inputValue;

        if (postType !== '-1') urlSuffix += '&pt=' + postType;

        window.location.replace(se_ajax.siteurl + urlSuffix);
    });
}

SearchMenu.prototype.show = function () {
    document.body.classList.add('no-overflow');
    this.el.classList.add('visible');

    var input = this.el.querySelector('input');
    input.focus();
};

SearchMenu.prototype.hide = function () {
    this.el.classList.remove('visible');
    document.body.classList.remove('no-overflow');
};

(function () {
    var searchMenuEl = document.querySelector('.jsSearchMenu');
    if (searchMenuEl) {
        var searchMenu = new SearchMenu(searchMenuEl);

        document.body.addEventListener('click', function (e) {
            if (e.target.classList.contains('jsTriggerSearchMenu')) {
                e.preventDefault();
                searchMenu.show();
            }
        });
    }
})();

function Accessibility() {
    this.modalEl = null;
    this.triggerEl = null;
    this.fontSizeCookie = null;
    this.contrastCookie = null;
    this.readspeakerCookie = null;
    this.contrastRadioEls = null;
    this.readspeakerRadioEls = null;

    this.init();
}

Accessibility.prototype.init = function () {
    this.modalEl = document.querySelector('.jsAccessibilityModal');
    this.triggerEl = document.querySelector('.jsAccessibilityTrigger');
    this.fontSizeCookie = this.getCookie('ab_font_size');
    this.contrastCookie = this.getCookie('ab_contrast');
    this.readspeakerCookie = this.getCookie('ab_readspeaker');

    if (!this.modalEl) return;

    this.contrastRadioEls = this.modalEl.querySelectorAll('input[name="contrast-enabled"]');
    this.readspeakerRadioEls = this.modalEl.querySelectorAll('input[name="readspeaker-enabled"]');

    if (this.fontSizeCookie) document.documentElement.classList.add(this.fontSizeCookie);else document.documentElement.classList.add('ab-font-size-0');

    if (this.contrastCookie === 'on') this.enableContrastMode();else this.disableContrastMode();

    if (this.contrastCookie === 'on') this.enableContrastMode();else this.disableContrastMode();

    if (this.readspeakerCookie === 'on') this.enableReadspeaker();else this.disableReadspeaker();

    this.setFontSizeButtons();
    this.addEventListeners();
};

Accessibility.prototype.addEventListeners = function () {
    var _this12 = this;

    // TODO: When clicking anywhere outside the modal, hide the modal

    if (this.triggerEl) {
        this.triggerEl.addEventListener('click', function (e) {
            e.preventDefault();
            _this12.toggleModal();
        });
    }

    if (this.modalEl) {
        this.modalEl.addEventListener('keydown', function (e) {
            if ((e.keyCode === 32 || e.keyCode === 13) && e.target.tagName.toLowerCase() === 'label') {
                e.preventDefault();
                var inputEl = e.target.parentElement.querySelector('input');
                inputEl.checked = !inputEl.checked;
            }
        });

        window.addEventListener('keyup', function (e) {
            if (e.key.toLowerCase() === 'escape') {
                _this12.hideModal();
            }
        });

        this.modalEl.addEventListener('click', function (e) {
            if (e.target.classList.contains('jsFontSizeSmaller')) _this12.makeFontSmaller();else if (e.target.classList.contains('jsFontSizeLarger')) _this12.makeFontBigger();
        });

        this.modalEl.addEventListener('change', function (e) {
            if (e.target.tagName.toLowerCase() === 'input' && e.target.name === 'contrast-enabled') {
                [].concat(_toConsumableArray(_this12.contrastRadioEls)).map(function (el) {
                    if (el.checked) {
                        if (parseInt(el.value) === 1) _this12.enableContrastMode();else if (parseInt(el.value) === 0) _this12.disableContrastMode();
                    }
                });
            } else if (e.target.tagName.toLowerCase() === 'input' && e.target.name === 'readspeaker-enabled') {
                [].concat(_toConsumableArray(_this12.readspeakerRadioEls)).map(function (el) {
                    if (el.checked) {
                        if (parseInt(el.value) === 1) _this12.enableReadspeaker();else if (parseInt(el.value) === 0) _this12.disableReadspeaker();
                    }
                });
            }
        });
    }
};

Accessibility.prototype.setFontSizeButtons = function () {
    this.modalEl.querySelector('.jsFontSizeSmaller').disabled = false;
    this.modalEl.querySelector('.jsFontSizeLarger').disabled = false;

    if (document.documentElement.classList.contains('ab-font-size-0')) this.modalEl.querySelector('.jsFontSizeSmaller').disabled = true;else if (document.documentElement.classList.contains('ab-font-size-2')) this.modalEl.querySelector('.jsFontSizeLarger').disabled = true;
};

Accessibility.prototype.toggleModal = function () {
    if (this.modalEl.classList.contains('show')) this.hideModal();else this.showModal();
};

Accessibility.prototype.showModal = function () {
    this.modalEl.classList.add('show');
};

Accessibility.prototype.hideModal = function () {
    this.modalEl.classList.remove('show');
};

Accessibility.prototype.makeFontBigger = function () {
    if (document.documentElement.classList.contains('ab-font-size-0')) {
        document.documentElement.classList.remove('ab-font-size-0');
        document.documentElement.classList.add('ab-font-size-1');
        document.cookie = 'ab_font_size=ab-font-size-1';
    } else if (document.documentElement.classList.contains('ab-font-size-1')) {
        document.documentElement.classList.remove('ab-font-size-1');
        document.documentElement.classList.add('ab-font-size-2');
        document.cookie = 'ab_font_size=ab-font-size-2';
    }

    this.setFontSizeButtons();
};

Accessibility.prototype.makeFontSmaller = function () {
    if (document.documentElement.classList.contains('ab-font-size-1')) {
        document.documentElement.classList.remove('ab-font-size-1');
        document.documentElement.classList.add('ab-font-size-0');
        document.cookie = 'ab_font_size=ab-font-size-0';
    } else if (document.documentElement.classList.contains('ab-font-size-2')) {
        document.documentElement.classList.remove('ab-font-size-2');
        document.documentElement.classList.add('ab-font-size-1');
        document.cookie = 'ab_font_size=ab-font-size-1';
    }

    this.setFontSizeButtons();
};

Accessibility.prototype.enableContrastMode = function () {
    document.documentElement.classList.add('ab-contrast');
    document.cookie = 'ab_contrast=' + 'on';

    [].concat(_toConsumableArray(this.contrastRadioEls)).map(function (el) {
        if (parseInt(el.value) === 1) el.checked = true;else el.checked = false;
    });
};

Accessibility.prototype.disableContrastMode = function () {
    document.documentElement.classList.remove('ab-contrast');
    document.cookie = 'ab_contrast=' + 'off';

    [].concat(_toConsumableArray(this.contrastRadioEls)).map(function (el) {
        if (parseInt(el.value) === 0) el.checked = true;else el.checked = false;
    });
};

Accessibility.prototype.enableReadspeaker = function () {
    document.documentElement.classList.add('ab-readspeaker');
    document.cookie = 'ab_readspeaker=' + 'on';

    [].concat(_toConsumableArray(this.readspeakerRadioEls)).map(function (el) {
        if (parseInt(el.value) === 1) el.checked = true;else el.checked = false;
    });
};

Accessibility.prototype.disableReadspeaker = function () {
    document.documentElement.classList.remove('ab-readspeaker');
    document.cookie = 'ab_readspeaker=' + 'off';

    [].concat(_toConsumableArray(this.readspeakerRadioEls)).map(function (el) {
        if (parseInt(el.value) === 0) el.checked = true;else el.checked = false;
    });
};

Accessibility.prototype.getCookie = function (name) {
    var dc = document.cookie;
    var prefix = name + '=';
    var end = '';
    var begin = dc.indexOf('; ' + prefix);

    if (begin === -1) {
        begin = dc.indexOf(prefix);
        if (begin !== 0) return null;
    } else {
        begin += 2;
        end = document.cookie.indexOf(";", begin);

        if (end === -1) end = dc.length;
    }

    return decodeURI(dc.substring(begin + prefix.length, end));
};

new Accessibility();

function ProgramModal(el) {
    var _this13 = this;

    this.el = el;

    this.el.addEventListener('click', function (e) {
        if (e.target.classList.contains('jsCloseModal')) {
            e.preventDefault();
            _this13.hide();
        }
    });

    window.addEventListener('keyup', function (e) {
        if (e.key.toLowerCase() === 'escape') _this13.hide();
    });
}

ProgramModal.prototype.show = function () {
    this.el.classList.add('visible');
};

ProgramModal.prototype.hide = function () {
    this.el.classList.remove('visible');
};

(function () {
    var programModalEl = document.querySelector('.jsProgramModal');

    if (programModalEl) {
        var programModal = new ProgramModal(programModalEl);

        document.addEventListener('click', function (e) {
            if (e.target.classList.contains('jsShowProgramModal')) {
                e.preventDefault();
                programModal.show();
            }
        });
    }
})();

function ConnectedThemesSlider(el) {
    this.el = el;

    var slider = new Flickity(this.el, {
        prevNextButtons: false,
        pageDots: false,
        cellAlign: 'left',
        contain: true
    });

    // Check if the slider has controls
    var controlWrapperEl = this.el.parentElement.querySelector('.jsSliderControls');
    if (controlWrapperEl) {
        controlWrapperEl.addEventListener('click', function (e) {
            e.preventDefault();

            if (e.target.classList.contains('prev')) slider.previous();else if (e.target.classList.contains('next')) slider.next();
        });
    }
}

(function () {
    var sliderEls = document.querySelectorAll('.jsConnectedThemeSlider');
    for (var i = 0; i < sliderEls.length; i++) {
        new ConnectedThemesSlider(sliderEls[i]);
    }
})();

function Anticonceptietool(el) {
    var _this14 = this;

    this.el = el;
    this.filtersEl = this.el.querySelector('.jsActiconceptieFilters');
    this.activeChoices = [];
    this.gridEl = this.el.querySelector('.jsAnticonceptietoolMethodeGrid');
    this.methodEls = this.el.querySelectorAll('.jsAnticonceptietoolMethodeGrid .jsTool');
    this.methododsAvailableEl = this.el.querySelector('.jsAnticonceptietoolItemsAvailable');
    this.noItemsEl = this.el.querySelector('.jsAnticonceptietoolNoItems');

    this.el.querySelector('.jsAnticonceptieToolResetBtn').addEventListener('click', function (e) {
        e.preventDefault();
        _this14.reset();
    });

    this.el.addEventListener('click', function (e) {
        if (e.target.classList.contains('jsAccordionTitle')) {
            e.preventDefault();

            var parent = e.target.parentElement;

            if (!parent.classList.contains('is-active')) {
                _this14.closeOpenAccordionElements();
                _this14.openAccordionEl(parent);
            } else {
                _this14.closeAccordionEl(parent);
            }
        }
    });

    this.filtersEl.addEventListener('change', function (e) {
        // When using radio buttons:
        _this14.activeChoices = [];
        var filterEls = _this14.filtersEl.querySelectorAll('input[type=radio]');
        for (var i = 0; i < filterEls.length; i++) {
            var _el = filterEls[i];

            if (_el.checked) {
                _this14.activeChoices.push(_el.value);
            }
        }

        // When using checkboxes
        // if (e.target.checked) {
        //     if (this.activeChoices.indexOf(e.target.value) === -1) this.activeChoices.push(e.target.value);
        // }
        // else {
        //     const index = this.activeChoices.indexOf(e.target.value);
        //     if (index > -1) this.activeChoices.splice(index, 1);
        // }

        // Process the result
        _this14.closeOpenAccordionElements();
        _this14.updateView();
    });

    this.methododsAvailableEl.addEventListener('click', function (e) {
        e.preventDefault();
        var bounds = _this14.gridEl.getBoundingClientRect();
        window.scrollTo({ top: window.scrollY + bounds.top - 80, behavior: 'smooth' });
    });

    this.setItemCounterVisibility();
    window.addEventListener('scroll', function (_) {
        return _this14.setItemCounterVisibility();
    });
}

Anticonceptietool.prototype.closeOpenAccordionElements = function () {
    var _this15 = this;

    [].concat(_toConsumableArray(this.el.querySelectorAll('.jsAccordionItem.is-active'))).map(function (item) {
        return _this15.closeAccordionEl(item);
    });
};

Anticonceptietool.prototype.openAccordionEl = function (element) {
    element.classList.add('is-active');
    var newHeight = element.offsetHeight;
    element.classList.remove('is-active');

    gsap.timeline().set(element, { height: element.offsetHeight }).add(function (_) {
        return element.classList.add('is-active');
    }).to(element, 0.25, { height: newHeight, ease: Power2.inOut }).set(element, { clearProps: 'all' });
};

Anticonceptietool.prototype.closeAccordionEl = function (element) {
    element.classList.remove('is-active');
    var newHeight = element.offsetHeight;
    element.classList.add('is-active');

    gsap.timeline().set(element, { height: element.offsetHeight }).to(element, 0.25, { height: newHeight, ease: Power2.inOut }).add(function (_) {
        return element.classList.remove('is-active');
    }).set(element, { clearProps: 'all' });
};

Anticonceptietool.prototype.updateView = function () {
    var _this16 = this;

    // Show the correct methods
    var activeMethodEls = this.getActiveMethodElsByFilterOptions(this.activeChoices, true);

    // Update the available choices
    var inputEls = this.el.querySelectorAll('input[type="checkbox"]');

    [].concat(_toConsumableArray(inputEls)).map(function (el) {
        // Set the enabled/disabled state
        var availableMethodEls = el.checked ? activeMethodEls : _this16.getActiveMethodElsByFilterOptions([].concat(_toConsumableArray(_this16.activeChoices), [el.value]), false);

        if (availableMethodEls.length === 0) el.disabled = true;else el.disabled = false;
    });

    // Update the accordion item headers
    [].concat(_toConsumableArray(this.el.querySelectorAll('.jsAccordionItem'))).map(function (item) {
        if (item.querySelector('input:checked')) item.classList.add('is-filled');else item.classList.remove('is-filled');
    });

    // Set the number of methods available
    this.methododsAvailableEl.querySelector('.number').innerHTML = activeMethodEls.length;

    // Show/hide the 'no items available' text
    if (activeMethodEls.length) this.noItemsEl.style.display = '';else this.noItemsEl.style.display = 'block';
};

Anticonceptietool.prototype.getActiveMethodElsByFilterOptions = function (activeOptions, disableWhenUnavailable) {
    // When there are no active filters, all items need to be visible
    if (activeOptions.length === 0) {
        var methodEls = [].concat(_toConsumableArray(this.methodEls));

        if (disableWhenUnavailable) methodEls.forEach(function (el) {
            return el.classList.remove('hidden');
        });
        return methodEls;
    }

    // Divide the active options array into a list for each filter
    var filters = {};

    activeOptions.forEach(function (option) {
        var optionSplit = option.split('_');
        if (typeof filters[optionSplit[0]] === 'undefined') filters[optionSplit[0]] = [];
        filters[optionSplit[0]].push(option);
    });

    var filterValues = Object.values(filters);

    // Get the available methods based on the selected filter values
    return [].concat(_toConsumableArray(this.methodEls)).filter(function (el) {
        var elTerms = el.dataset.taxonomies.split(' ');

        // For each filter, if one of the terms is set, we're good. If one filter returns false for all terms, we're not good
        for (var i = 0; i < filterValues.length; i++) {
            var isAvailable = false;

            // For each filter, check if the element has at lease one term (OR)
            for (var j = 0; j < filterValues[i].length; j++) {
                if (elTerms.indexOf(filterValues[i][j]) > -1) {
                    isAvailable = true;
                    break;
                }
            }

            // If one of the filters is unavailable, hide the element (AND)
            if (!isAvailable) {
                if (disableWhenUnavailable) el.classList.add('hidden');
                return false;
            }
        }

        if (disableWhenUnavailable) el.classList.remove('hidden');
        return true;
    });
};

Anticonceptietool.prototype.reset = function () {
    [].concat(_toConsumableArray(this.methodEls)).map(function (el) {
        return el.classList.remove('hidden');
    });

    this.filtersEl.reset();
    this.activeChoices = [];
    this.updateView();
};

Anticonceptietool.prototype.setItemCounterVisibility = function () {
    var bounds = this.gridEl.getBoundingClientRect();

    if (bounds.top - window.innerHeight < -(window.innerHeight * 0.5)) this.methododsAvailableEl.classList.add('hidden');else this.methododsAvailableEl.classList.remove('hidden');
};

(function () {
    var anticonceptietoolEl = document.querySelector('.jsAnticonceptietool');
    if (anticonceptietoolEl) new Anticonceptietool(anticonceptietoolEl);
})();

(function () {
    var suggestSearchBoxEl = document.querySelector('.jsSearchFormWithSuggestions');

    if (suggestSearchBoxEl) {
        var suggestionBox = suggestSearchBoxEl.querySelector('.jsSuggestionBox');
        var input = suggestSearchBoxEl.querySelector('input.input');
        var searchTimeout = null;

        input.addEventListener('keyup', function (e) {
            if (input.value === '') {
                suggestionBox.classList.remove('visible');
                return;
            }

            if (searchTimeout) clearTimeout(searchTimeout);
            searchTimeout = null;
            searchTimeout = setTimeout(function (_) {
                se_postRequest(se_ajax.ajaxurl, { action: 'get_search_suggestions', query: input.value }, function (response) {
                    if (response) {
                        suggestionBox.innerHTML = response;
                        suggestionBox.classList.add('visible');
                    } else {
                        suggestionBox.classList.remove('visible');
                    }
                }, function (_) {
                    console.error('Something went wrong while searching');
                });
            }, 200);
        });

        window.addEventListener('keyup', function (e) {
            if (e.key.toLowerCase() === 'escape') suggestionBox.classList.remove('visible');
        });

        window.addEventListener('click', function (_) {
            suggestionBox.classList.remove('visible');
        });
    }
})();

(function () {
    var footerLinkEls = document.body.querySelectorAll('.footer a[href="#"]');

    footerLinkEls.forEach(function (el) {
        el.addEventListener('click', function (e) {
            return e.preventDefault();
        });
    });
})();

function ThemeSwitcher(el) {
    var _this17 = this;

    this.el = el;

    document.body.addEventListener('click', function (e) {
        if (e.target.classList.contains('jsThemeSwitcherThemeTitle')) _this17.el.classList.toggle('open');else _this17.el.classList.remove('open');
    });
}

(function () {
    [].concat(_toConsumableArray(document.querySelectorAll('.jsThemeSwitcher'))).forEach(function (el) {
        return new ThemeSwitcher(el);
    });
})();

function DifficultWordModal() {
    this.init();
    this.setEventListeners();
}

DifficultWordModal.prototype.init = function () {
    this.el = document.createElement('div');
    this.el.classList.add('difficult-word-modal');
    this.el.classList.add('jsCloseModal');

    this.el.innerHTML = '\n        <div class="difficult-word-modal__inner">\n            <button class="difficult-word-modal__close-btn jsCloseModal" type="button">Sluiten</button>\n            <span class="difficult-word-modal__title jsTitle"></span>\n            <div class="office-project-modal__content default-styles jsContent"></div>\n        </div>    \n    ';

    document.body.appendChild(this.el);

    this.titleEl = this.el.querySelector('.jsTitle');
    this.contentEl = this.el.querySelector('.jsContent');
};

DifficultWordModal.prototype.setEventListeners = function () {
    var _this18 = this;

    this.el.addEventListener('click', function (e) {
        if (e.target.classList.contains('jsCloseModal')) {
            e.preventDefault();
            _this18.hide();
        }
    });

    window.addEventListener('keyup', function (e) {
        if (e.key.toLowerCase() === 'escape') _this18.hide();
    });
};

DifficultWordModal.prototype.set = function (title, content) {
    this.titleEl.innerHTML = title;
    this.contentEl.innerHTML = content;
};

DifficultWordModal.prototype.show = function () {
    this.el.classList.add('visible');
};

DifficultWordModal.prototype.hide = function () {
    this.el.classList.remove('visible');
};

(function () {
    var modal = null;
    document.body.addEventListener('click', function (e) {
        if (e.target.classList.contains('jsDifficultWord')) {
            e.preventDefault();

            if (!modal) modal = new DifficultWordModal();
            modal.set(e.target.dataset.title, e.target.dataset.explanation);
            modal.show();
        }
    });
})();
function SePopup(triggerEl) {
    var _this19 = this;

    this.el = null;
    this.innerEl = null;
    this.triggerEl = triggerEl;
    this.initialized = false;
    this.bodyHadOverflow = false;

    this.triggerEl.addEventListener('click', function (e) {
        e.preventDefault();

        if (e.target.classList.contains('jsShowPopup')) _this19.show();else if (e.target.classList.contains('jsHideTrigger')) _this19.hideTrigger();
    });

    window.addEventListener('keyup', function (e) {
        if (e.key.toLowerCase() === 'escape') _this19.hide();
    });

    this.showTrigger();
}

SePopup.prototype._init = function () {
    var _this20 = this;

    this.initialized = true;

    // Create the popup
    this.el = document.createElement('div');
    this.el.classList.add('se-popup');
    this.el.classList.add('jsClosePopup');

    this.el.innerHTML = '' + '<div class="se-popup__inner">' + '<button class="se-popup__close-btn jsClosePopup">Close</button>' + '<span class="se-popup__title">' + JSON.parse(this.triggerEl.dataset.popupTitle) + '</span>' + '<div class="se-popup__content default-styles text-color-' + this.triggerEl.dataset.textColor + '">' + JSON.parse(this.triggerEl.dataset.popupContent) + '</div>' + '</div>';

    this.innerEl = this.el.querySelector('.se-popup__inner');
    this.innerEl.classList.add('text-color-' + this.triggerEl.dataset.textColor);
    this.innerEl.classList.add('bg-color-' + this.triggerEl.dataset.bgColor + '-1');

    var contentBtnEls = this.innerEl.querySelectorAll('.btn');
    contentBtnEls.forEach(function (el) {
        el.className = '';
        el.classList.add('btn');
        el.classList.add('btn--arrow');
        el.classList.add('text-color-' + _this20.triggerEl.dataset.bgColor + '-1');
        el.classList.add('bg-color-white');
    });

    document.body.appendChild(this.el);

    // Add event listeners
    this.el.addEventListener('click', function (e) {
        if (e.target.classList.contains('jsClosePopup')) {
            e.preventDefault();
            _this20.hide();
        }
    });
};

SePopup.prototype.showTrigger = function () {
    var _this21 = this;

    var hideCookie = document.cookie.split(';').find(function (c) {
        return c.trim().startsWith('se_hide_popup_' + _this21.triggerEl.dataset.popupId);
    });
    if (hideCookie) return;

    setTimeout(function () {
        gsap.timeline().set(_this21.triggerEl, { opacity: 0, y: -20 }).add(function () {
            _this21.triggerEl.classList.add('visible');
            _this21.triggerEl.classList.add('no-transition');
        }).to(_this21.triggerEl, { duration: 0.5, opacity: 1, ease: 'power2.inOut' }).to(_this21.triggerEl, { duration: 0.8, y: 0, ease: 'Bounce.easeOut' }, '-=0.5').add(function (_) {
            return _this21.triggerEl.classList.remove('no-transition');
        }).add(function () {
            if (_this21.triggerEl.classList.contains('jsShowLarge')) {
                var _hideCookie = document.cookie.split(';').find(function (c) {
                    return c.trim().startsWith('se_hide_init_popup_' + _this21.triggerEl.dataset.popupId);
                });
                if (!_hideCookie) _this21.show();
            }
        });
    }, parseInt(this.triggerEl.dataset.appearTimeout) * 1000);
};

SePopup.prototype.show = function () {
    var _this22 = this;

    if (!this.initialized) this._init();

    this.bodyHadOverflow = document.body.classList.contains('no-overflow');
    document.body.classList.add('no-overflow');

    gsap.timeline().set(this.el, { opacity: 0 }).set(this.innerEl, { scale: 0.9 }).add(function () {
        return _this22.el.classList.add('visible');
    }).to(this.el, { duration: 0.5, opacity: 1, ease: 'power2.inOut' }).to(this.innerEl, { duration: 0.5, scale: 1, ease: 'power2.inOut' }, '-=0.5').set(this.el, { clearProps: 'all' });
};

SePopup.prototype.hide = function () {
    var _this23 = this;

    if (!this.initialized) return;
    if (this.triggerEl.classList.contains('jsShowLarge')) document.cookie = 'se_hide_init_popup_' + this.triggerEl.dataset.popupId + '=true; path=/; SameSite=Lax';

    // Remove the overflow from the body
    if (!this.bodyHadOverflow) {
        document.body.classList.remove('no-overflow');
    }

    gsap.timeline().to(this.el, { duration: 0.5, opacity: 0, ease: 'power2.inOut' }).to(this.innerEl, { duration: 0.5, scale: 0.9, ease: 'power2.inOut' }, '-=0.5').add(function () {
        return _this23.el.classList.remove('visible');
    }).set(this.el, { clearProps: 'all' });
};

SePopup.prototype.hideTrigger = function () {
    // Set a cookie so we remember to not show it again
    document.cookie = 'se_hide_popup_' + this.triggerEl.dataset.popupId + '=true; path=/; SameSite=Lax';

    // Hide the trigger element
    this.triggerEl.classList.add('no-transition');

    gsap.timeline().to(this.triggerEl, { duration: 0.5, x: 100, opacity: 0, ease: 'power2.inOut' }).set(this.triggerEl, { display: 'none' });
};

(function () {
    var popupTriggerEls = document.querySelectorAll('.jsPopupTrigger');
    popupTriggerEls.forEach(function (el) {
        return new SePopup(el);
    });
})();
function Compare(el) {
    this.el = el;
    this.init();
}

Compare.prototype.init = function () {
    var _this24 = this;

    this.sliderEl = this.el.querySelector('.jsCompareList');
    this.slideCount = this.sliderEl.querySelectorAll('.compare-product').length;
    this.prevBtnEl = this.el.querySelector('.jsPrev');
    this.nextBtnEl = this.el.querySelector('.jsNext');
    this.flickity = new Flickity(this.sliderEl, {
        prevNextButtons: false,
        pageDots: false,
        cellAlign: 'left',
        contain: false,
        imagesLoaded: true
    });

    this.setLineHeights();
    window.addEventListener('resize', function () {
        return _this24.setLineHeights();
    });

    this.el.addEventListener('click', function (e) {
        if (e.target.classList.contains('jsPrev')) {
            e.preventDefault();
            _this24.flickity.previous();
        } else if (e.target.classList.contains('jsNext')) {
            e.preventDefault();
            _this24.flickity.next();
        }
    });

    this.flickity.on('change', function (index) {
        _this24.prevBtnEl.disabled = false;
        _this24.nextBtnEl.disabled = false;

        if (index === 0) _this24.prevBtnEl.disabled = true;
        if (index === _this24.slideCount - 1) _this24.nextBtnEl.disabled = true;
    });
};

Compare.prototype.setLineHeights = function () {
    var _this25 = this;

    var _loop2 = function _loop2(i) {
        var elements = _this25.el.querySelectorAll('[data-eh="' + i + '"]');
        var maxHeight = 0;

        [].concat(_toConsumableArray(elements)).map(function (el) {
            el.style.height = '';
            if (el.offsetHeight > maxHeight) maxHeight = el.offsetHeight;
        });

        gsap.set(elements, { height: maxHeight });
    };

    for (var i = 1; i <= 9; i++) {
        _loop2(i);
    }

    var firstCompareProductEl = this.el.querySelector('.jsCompareProduct.first');
    var compareProductEls = this.el.querySelectorAll('.jsCompareProduct:not(.first)');
    gsap.set(compareProductEls, { width: firstCompareProductEl.offsetWidth });

    this.flickity.resize();
};

(function () {
    var complareEls = document.body.querySelectorAll('.jsCompare');
    [].concat(_toConsumableArray(complareEls)).forEach(function (el) {
        return new Compare(el);
    });
})();
function Seksscan(el) {
    var _this26 = this;

    this.el = el;

    this.startEl = this.el.querySelector('.jsStart');
    this.questionsEl = this.el.querySelector('.jsQuestions');
    this.resultEl = this.el.querySelector('.jsResult');

    this.progressEl = this.el.querySelector('.jsProgress');
    this.paginationBtnEls = this.el.querySelector('.jsPaginationBtns');

    this.questionEls = this.el.querySelectorAll('.jsQuestion');
    this.currentQuestionIndex = 0;
    this.questionCount = this.questionEls.length;
    this.defaultQuestionCount = 0;
    this.questionAnswers = [];
    this.answerBtnwrapper = this.el.querySelector('.jsAnswerBtns');
    this.multiAnswerBtnWrapper = this.el.querySelector('.jsAnswerBtnsMulti');
    this.percentageEl = this.el.querySelector('.jsResult .jsPercentage');

    this.formEl = this.el.querySelector('.jsResultForm');
    this.formEmailInput = this.formEl.querySelector('input[type="email"]');
    this.firstNameInput = this.el.querySelector('.jsFirstName');

    this.currentPage = 'start';

    this.resetQuestionAnswers();

    window.dataLayer = window.dataLayer || [];

    this.updateBtnVisibility();
    this.setDefaultQuestionCount();

    // Check if we have existing results
    var existingResults = localStorage.getItem('rutgers_seksscan_temp_results');

    if (existingResults) {
        existingResults = JSON.parse(existingResults);

        if (existingResults.length && existingResults.length === this.questionCount) {
            this.startEl.classList.add('has-results');
            this.questionAnswers = existingResults;
        } else {
            this.clearLocalStorage();
        }
    }

    // Start the scan
    this.startEl.addEventListener('click', function (e) {
        var isNew = e.target.classList.contains('jsStartNew');
        var isContinue = e.target.classList.contains('jsStartContinue');
        if (!isNew && !isContinue) return;

        if (isNew) {
            _this26.clearLocalStorage();
            _this26.resetQuestionAnswers();
            _this26.currentQuestionIndex = 0;

            _this26.currentPage = 'questions';

            _this26.startEl.classList.remove('active');
            _this26.questionsEl.classList.add('active');
            _this26.resultEl.classList.remove('active');
            _this26.showActiveQuestion();

            window.dataLayer.push({ event: 'seksscan_start', method: 'new_scan' });
        } else if (isContinue) {
            _this26.currentPage = 'questions';

            // Go the the first question that has no answer (or the last)
            _this26.currentQuestionIndex = _this26.questionAnswers.indexOf('') > -1 ? _this26.questionAnswers.indexOf('') : _this26.questionCount - 1;
            _this26.showActiveQuestion();

            _this26.startEl.classList.remove('active');
            _this26.questionsEl.classList.add('active');
            _this26.resultEl.classList.remove('active');

            window.dataLayer.push({ event: 'seksscan_start', method: 'continue_existing_scan' });
        }
    });

    this.paginationBtnEls.addEventListener('click', function (e) {
        if (e.target.classList.contains('jsPrev')) {
            window.dataLayer.push({ event: 'seksscan_skip_question', questionTitle: _this26.getCurrentQuestionTitle(), direction: 'previous' });
            _this26.prevQuestion();
        } else if (e.target.classList.contains('jsNext')) {
            if (!_this26.isNextQuestionAllowed()) return;

            window.dataLayer.push({ event: 'seksscan_skip_question', questionTitle: _this26.getCurrentQuestionTitle(), direction: 'next' });
            _this26.nextQuestion();
        }
    });

    this.answerBtnwrapper.addEventListener('click', function (e) {
        if (e.target.classList.contains('jsAnswerBtn')) {
            if (e.target.classList.contains('jsYes')) {
                _this26.questionAnswers[_this26.currentQuestionIndex] = 'yes';
                window.dataLayer.push({ event: 'seksscan_answer_yes', questionTitle: _this26.getCurrentQuestionTitle() });
            } else if (e.target.classList.contains('jsNo')) {
                _this26.questionAnswers[_this26.currentQuestionIndex] = 'no';
                window.dataLayer.push({ event: 'seksscan_answer_no', questionTitle: _this26.getCurrentQuestionTitle() });
            } else if (e.target.classList.contains('jsDontKnow')) {
                _this26.questionAnswers[_this26.currentQuestionIndex] = 'idk';
                window.dataLayer.push({ event: 'seksscan_answer_idk', questionTitle: _this26.getCurrentQuestionTitle() });
            }

            _this26.updateLocalStorage();
            _this26.nextQuestion();
        }
    });

    this.multiAnswerBtnWrapper.addEventListener('click', function (e) {
        if (!e.target.classList.contains('jsContinue')) return;

        var checkboxAnswers = _this26.questionEls[_this26.currentQuestionIndex].querySelectorAll('input[type="checkbox"]:checked');
        var selectedAnswers = [].concat(_toConsumableArray(checkboxAnswers)).map(function (el) {
            return el.value;
        });

        var otherInputEl = _this26.questionEls[_this26.currentQuestionIndex].querySelector('input[type="text"]');
        var otherValue = otherInputEl ? otherInputEl.value.trim() : '';

        if (otherValue !== '') selectedAnswers.push('Anders: ' + otherValue);

        if (!selectedAnswers.length) {
            alert('Kies één of meerdere antwoorden om door te gaan.');
            return;
        }

        _this26.questionAnswers[_this26.currentQuestionIndex] = selectedAnswers;
        window.dataLayer.push({ event: 'seksscan_answer_multi', questionTitle: _this26.getCurrentQuestionTitle(), answers: selectedAnswers.join(', ') });

        _this26.updateLocalStorage();
        _this26.nextQuestion();
    });

    this.formEl.addEventListener('submit', function (e) {
        e.preventDefault();
        if (_this26.currentPage !== 'result') return;

        var email = _this26.formEmailInput.value.trim();
        var firstName = _this26.firstNameInput.value.trim();

        // Check if whe have an email address
        if (email === '') {
            alert('Voer eerst een geldig e-mailadres in om door te gaan');
            return;
        }

        // Check if the email address seems valid
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            alert('Voer eerst een geldig e-mailadres in om door te gaan');
            return;
        }

        _this26.formEl.classList.add('loading');

        // Send the request
        se_postRequest(se_ajax.ajaxurl, { action: 'generate_seksscan_pdf', scores: JSON.stringify(_this26.questionAnswers), email: email, firstName: firstName }, function (response) {
            _this26.formEl.classList.remove('loading');
            response = (response || '').trim();

            if (response === 'invalid-email') {
                alert('Voer eerst een geldig e-mailadres in om door te gaan');
                return;
            } else if (response === 'success') {
                _this26.formEl.classList.add('success');
                window.dataLayer.push({ event: 'seksscan_result_email_send' });
                _this26.clearLocalStorage();
                return;
            }

            alert('Er ging iets fout bij het versturen van de resultaten. Probeer het nogmaals of neem contact met ons op.');
        }, function (_) {
            _this26.formEl.classList.remove('loading');
            console.error('Something went wrong while sending the request. Please try again or contact us.');
            alert('Er ging iets fout bij het versturen van de resultaten. Probeer het nogmaals of neem contact met ons op.');
        });
    });
}

Seksscan.prototype.setDefaultQuestionCount = function () {
    var count = 0;

    [].concat(_toConsumableArray(this.questionEls)).map(function (el) {
        if (el.dataset.questionType === 'default') count++;
    });
    this.defaultQuestionCount = count;
};

Seksscan.prototype.getCurrentQuestionTitle = function () {
    return this.questionEls[this.currentQuestionIndex].querySelector('.jsQuestionTitle').innerHTML;
};

Seksscan.prototype.resetQuestionAnswers = function () {
    this.questionAnswers = [].concat(_toConsumableArray(this.questionEls)).map(function () {
        return '';
    });
};

Seksscan.prototype.updateLocalStorage = function () {
    localStorage.setItem('rutgers_seksscan_temp_results', JSON.stringify(this.questionAnswers));
};

Seksscan.prototype.clearLocalStorage = function () {
    localStorage.removeItem('rutgers_seksscan_temp_results');
};

Seksscan.prototype.updateProgress = function () {
    this.progressEl.innerHTML = this.currentQuestionIndex + 1 + '/' + this.questionCount;
};

Seksscan.prototype.updateBtnVisibility = function () {
    // Show/hide the previous button
    if (this.currentQuestionIndex === 0) this.paginationBtnEls.querySelector('.jsPrev').classList.add('hidden');else this.paginationBtnEls.querySelector('.jsPrev').classList.remove('hidden');

    // Show/hide the next button
    if (this.questionAnswers[this.currentQuestionIndex] === '') this.paginationBtnEls.querySelector('.jsNext').classList.add('hidden');else this.paginationBtnEls.querySelector('.jsNext').classList.remove('hidden');

    // Show/hide the answer buttons
    if (this.questionEls[this.currentQuestionIndex].dataset.questionType === 'default') {
        this.answerBtnwrapper.classList.remove('hidden');
        this.multiAnswerBtnWrapper.classList.add('hidden');
    } else {
        this.answerBtnwrapper.classList.add('hidden');
        this.multiAnswerBtnWrapper.classList.remove('hidden');
    }
};

Seksscan.prototype.isNextQuestionAllowed = function () {
    return this.questionAnswers[this.currentQuestionIndex] !== '';
};

Seksscan.prototype.nextQuestion = function () {
    this.currentQuestionIndex++;

    if (this.currentQuestionIndex > this.questionCount - 1) {
        this.currentQuestionIndex = this.questionCount - 1;

        this.showResult();
        return;
    }

    this.showActiveQuestion();
};

Seksscan.prototype.showActiveQuestion = function () {
    var _this27 = this;

    [].concat(_toConsumableArray(this.questionEls)).map(function (el, index) {
        if (index === _this27.currentQuestionIndex) {
            if (typeof _this27.questionAnswers[_this27.currentQuestionIndex] !== 'string') {
                // Check the checkboxes
                _this27.questionEls[_this27.currentQuestionIndex].querySelectorAll('input[type="checkbox"]').forEach(function (checkboxEl) {
                    checkboxEl.checked = _this27.questionAnswers[_this27.currentQuestionIndex].includes(checkboxEl.value);
                });

                // Set the input value
                var inputEl = _this27.questionEls[_this27.currentQuestionIndex].querySelector('input[type="text"]');
                if (inputEl) {
                    var otherValue = _this27.questionAnswers[_this27.currentQuestionIndex].find(function (answer) {
                        return answer.includes('Anders: ');
                    });
                    inputEl.value = otherValue ? otherValue.replace('Anders: ', '') : '';
                }
            } else {
                // Check the answer buttons
                _this27.answerBtnwrapper.querySelectorAll('.jsAnswerBtn').forEach(function (btn) {
                    if (_this27.questionAnswers[_this27.currentQuestionIndex] === btn.dataset.answer) btn.classList.add('checked');else btn.classList.remove('checked');
                });
            }

            // Activate the question
            el.classList.add('active');
        } else el.classList.remove('active');
    });

    this.updateBtnVisibility();
    this.updateProgress();
};

Seksscan.prototype.prevQuestion = function () {
    this.currentQuestionIndex--;
    if (this.currentQuestionIndex < 0) this.currentQuestionIndex = 0;

    this.showActiveQuestion();
};

Seksscan.prototype.showResult = function () {
    this.startEl.classList.remove('active');
    this.questionsEl.classList.remove('active');
    this.resultEl.classList.add('active');

    this.currentPage = 'result';

    var yesScore = this.questionAnswers.filter(function (answer) {
        return answer === 'yes';
    }).length;
    var otherScore = this.questionAnswers.filter(function (answer) {
        return Array.isArray(answer) ? false : answer !== 'yes';
    }).length;

    var yesScorePercentage = Math.round(yesScore / this.defaultQuestionCount * 100);

    var scoreDescEl = yesScorePercentage >= 75 ? this.el.querySelector('.jsDescGood') : this.el.querySelector('.jsDescImprovement');
    var otherScoreDescEl = yesScorePercentage >= 75 ? this.el.querySelector('.jsDescImprovement') : this.el.querySelector('.jsDescGood');

    scoreDescEl.innerHTML = scoreDescEl.innerHTML.replace('#YES_COUNT#', yesScore);
    scoreDescEl.innerHTML = scoreDescEl.innerHTML.replace('#OTHER_COUNT#', otherScore);

    this.percentageEl.innerHTML = Math.round(yesScorePercentage) + '%';
    document.documentElement.style.setProperty('--seksscan-result-percentage', yesScorePercentage + '%');

    scoreDescEl.classList.add('active');
    otherScoreDescEl.classList.remove('active');

    window.dataLayer.push({ event: 'seksscan_completed', percentage: yesScorePercentage });
};

(function () {
    var seksscanEl = document.querySelector('.jsSeksscan');
    if (seksscanEl) new Seksscan(seksscanEl);
})();

function EventSignupModal(el) {
    this.el = el;
    this.init();
}

EventSignupModal.prototype.init = function () {
    var _this28 = this;

    document.body.addEventListener('click', function (e) {
        if (e.target.classList.contains('jsTriggerEventSignupModal')) {
            e.preventDefault();
            _this28.open();
        }
    });

    this.el.addEventListener('click', function (e) {
        if (e.target.classList.contains('jsClose')) {
            e.preventDefault();
            _this28.close();
        }
    });

    window.addEventListener('keyup', function (e) {
        if (e.key.toLowerCase() === 'escape') {
            _this28.close();
        }
    });
};

EventSignupModal.prototype.open = function () {
    this.el.classList.add('is-active');
};

EventSignupModal.prototype.close = function () {
    this.el.classList.remove('is-active');
};

(function () {
    var eventSignupModalEl = document.querySelector('.jsEventSignupModal');
    if (eventSignupModalEl) new EventSignupModal(eventSignupModalEl);
})();

function SeRutQuiz(el) {
    var _this29 = this;

    this.el = el;
    this.parentSection = this.el.parentElement;
    this.quizId = this.el.dataset.quizId;
    this.questions = JSON.parse(this.el.dataset.questions);
    this.summarySentences = JSON.parse(this.el.dataset.summarySentences);
    this.hadInteraction = false;
    this.activeScreen = 'start';
    this.backBtnEl = this.parentSection.querySelector('.jsBackBtn');
    this.replaceStringEls = this.el.querySelectorAll('.jsReplaceVariables');
    this.backBtnEventListeners = [];
    this.sourceEl = this.parentSection.querySelector('.jsTestSource');

    this.screens = {
        start: this.el.querySelector('.jsScreenStart'),
        questions: this.el.querySelector('.jsScreenQuestions'),
        singleResult: this.el.querySelector('.jsScreenSingleResult')
    };

    this.inputP1NameEl = this.el.querySelector('input[name="input-p1"]');
    this.urlData = { name: null };

    // Get the question elements
    this.currentQuestionIndex = 0;
    this.questionEls = this.screens.questions.querySelectorAll('.jsQuestion');
    this.questionCount = this.questionEls.length;

    for (var i = 0; i < this.questionCount; i++) {
        this.urlData['a' + (i + 1)] = null;
    }

    // Init the test
    this.init();

    this.backBtnEl.addEventListener('click', function (e) {
        e.preventDefault();

        // Call the event listeners
        _this29.backBtnEventListeners.forEach(function (listener) {
            return listener();
        });

        // Do screen based navigation
        switch (_this29.activeScreen) {
            case 'singleResult':
                _this29.goToScreen('questions');
                break;
        }
    });

    // Add a transition to anchor links
    document.body.addEventListener('click', function (e) {
        if (e.target.classList.contains('jsAnchorBtn')) {
            e.preventDefault();

            var _el2 = document.getElementById(e.target.href.split('#')[1]);
            var bounds = _el2.getBoundingClientRect();

            vanillaSmoothie.scrollTo(bounds.top + window.scrollY - _this29.getResponsiveTopOffset(), { easing: 'easeInOutQuad' });
        }
    });
};

SeRutQuiz.prototype.init = function () {
    this.hideSource();
    this.initStartScreen();
    this.initSingleResultScreen();
    this.initActiveScreen();
};

SeRutQuiz.prototype.addBackBtnEventListener = function (listener) {
    this.backBtnEventListeners.push(listener);
};

SeRutQuiz.prototype.capitalizeFirstLetter = function (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

SeRutQuiz.prototype.goToScreen = function (screen) {
    this.hideSource();

    // Replace variables in strings
    this.replaceVariablesInStrings();

    // Hide all screens
    Object.values(this.screens).forEach(function (screen) {
        return screen.classList.remove('active');
    });

    // Show the correct screen
    this.screens[screen].classList.add('active');

    // Start logics for the correct screen
    switch (screen) {
        case 'start':
            this.hideBackArrow();break;
        case 'questions':
            this.startQuizScreen();break;
        case 'singleResult':
            this.initSingleResultScreen();break;
    }

    this.activeScreen = screen;
    this.hadInteraction = true;
};

SeRutQuiz.prototype.showBackArrow = function () {
    this.backBtnEl.classList.add('visible');
};

SeRutQuiz.prototype.hideBackArrow = function () {
    this.backBtnEl.classList.remove('visible');
};

SeRutQuiz.prototype.startQuizScreen = function () {
    var _this30 = this;

    if (!this.screens.start.classList.contains('initialized')) {
        this.screens.start.classList.add('initialized');

        this.addBackBtnEventListener(function () {
            if (_this30.activeScreen === 'questions') {
                _this30.goToPrevQuestionView();
            }
        });
    }

    // Activate the first question
    this.questionEls.forEach(function (el) {
        return el.classList.remove('active');
    });
    this.questionEls[this.currentQuestionIndex].classList.add('active');

    this.screens.questions.addEventListener('change', function (e) {
        if (e.target.tagName.toLowerCase() === 'input') {
            // Check if the user has given an answer
            var checkedAnswerEl = _this30.questionEls[_this30.currentQuestionIndex].querySelector('input:checked');
            if (!checkedAnswerEl) return alert('Selecteer eerst een antwoord om door te gaan');

            // Save the answer
            _this30.urlData['a' + (_this30.currentQuestionIndex + 1)] = parseInt(checkedAnswerEl.value);

            // Send data to Analytics
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({ 'event': 'question_answered', 'quiz_id': _this30.quizId, 'question_name': '(' + _this30.quizId + ') ' + _this30.questions[_this30.currentQuestionIndex].analytics_title });
                dataLayer.push({ 'event': 'answer_given', 'quiz_id': _this30.quizId, 'question_name': '(' + _this30.quizId + ') ' + _this30.questions[_this30.currentQuestionIndex].analytics_title, 'answer_name': '(' + _this30.quizId + ') ' + _this30.questions[_this30.currentQuestionIndex].answers[checkedAnswerEl.value].associated_sentence });
            }

            // If the question had a video, pause it
            if (_this30.questions[_this30.currentQuestionIndex]['youtube_embed_url']) {
                var videoEl = _this30.questionEls[_this30.currentQuestionIndex].querySelector('.jsQuestionVideo iframe');
                videoEl.src = videoEl.src;
            }

            // Show the statistics screen
            _this30.showBackArrow();
            _this30.questionEls[_this30.currentQuestionIndex].classList.add('show-statistics');
            _this30.screens.questions.classList.add('show-statistics');

            // Add the source
            if (_this30.questions[_this30.currentQuestionIndex]['source_reference']) {
                _this30.setSource(_this30.questions[_this30.currentQuestionIndex]['source_reference']);
                _this30.showSource();
            } else {
                _this30.hideSource();
            }

            var bounds = _this30.parentSection.getBoundingClientRect();
            vanillaSmoothie.scrollTo(bounds.top + window.scrollY - _this30.getResponsiveTopOffset(), { easing: 'easeInOutQuad' });
        }
    });

    // Listen for events
    this.screens.questions.addEventListener('click', function (e) {
        if (e.target.classList.contains('jsNextQuestion')) {
            e.preventDefault();
            _this30.goToNextQuestion();
        }
    });
};

SeRutQuiz.prototype.getResponsiveTopOffset = function () {
    if (window.innerWidth < 1100) return 0;

    var headerEl = document.querySelector('.header');

    // Check if the header is fixed
    var headerStyle = window.getComputedStyle(headerEl);
    if (headerStyle.position !== 'fixed') return 0;

    return headerEl.offsetHeight;
};

SeRutQuiz.prototype.goToPrevQuestionView = function () {
    // If we're on the statistics screen, show the question
    if (this.screens.questions.classList.contains('show-statistics')) {
        this.questionEls[this.currentQuestionIndex].classList.remove('show-statistics');
        this.screens.questions.classList.remove('show-statistics');

        // Reset the radio buttons
        var radioBtnEls = this.screens.questions.querySelectorAll('.question[data-question-index="' + this.currentQuestionIndex + '"] input[type="radio"]');
        radioBtnEls.forEach(function (el) {
            return el.checked = false;
        });
    }
    // If we're on the question screen, go to the previous question and show its statistics
    else {
            // Update the question index
            this.currentQuestionIndex--;
            if (this.currentQuestionIndex < 0) this.currentQuestionIndex = 0;

            // Go to the question
            this.goToQuestion(this.currentQuestionIndex);

            // Show the statistics
            this.questionEls[this.currentQuestionIndex].classList.add('show-statistics');
            this.screens.questions.classList.add('show-statistics');
        }

    // Hide the back arrow when we're at the first question (and not at it's statistics)
    if (this.currentQuestionIndex === 0 && !this.screens.questions.classList.contains('show-statistics')) {
        this.hideBackArrow();
    }
};

SeRutQuiz.prototype.goToNextQuestion = function () {
    this.hideSource();

    // Show the next question or go to the next screen
    var nextQuestionIndex = this.currentQuestionIndex + 1;

    if (nextQuestionIndex > this.questionCount - 1) {
        // Trigger the completed_personal_check action in GTM
        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({ 'event': 'completed_personal_check', 'quiz_id': this.quizId, 'quiz_score': this.calculateCurrentUserScore() });
            dataLayer.push({ 'event': 'quiz_result_index', 'quiz_id': this.quizId, 'quiz_result_index': this.getSingleResultIndex() });
        }

        return this.goToScreen('singleResult');
    } else {
        this.currentQuestionIndex = nextQuestionIndex;
        this.goToQuestion(nextQuestionIndex);
    }
};

SeRutQuiz.prototype.goToQuestion = function (index) {
    this.showBackArrow();

    // Reset all questions to start with the question instead of the answer
    this.questionEls.forEach(function (el) {
        return el.classList.remove('show-statistics');
    });
    this.screens.questions.classList.remove('show-statistics');

    // Scroll to the top of the test
    var bounds = this.parentSection.getBoundingClientRect();
    vanillaSmoothie.scrollTo(bounds.top + window.scrollY - this.getResponsiveTopOffset(), { easing: 'easeInOutQuad' });

    // Show the question
    this.questionEls.forEach(function (el) {
        return el.classList.remove('active');
    });
    this.questionEls[index].classList.add('active');
};

SeRutQuiz.prototype.initActiveScreen = function () {
    // Hide all screens
    Object.values(this.screens).forEach(function (screen) {
        return screen.classList.remove('active');
    });

    // Check if all questions have already been answered, go to the single result screen
    if (this.urlData['a' + this.questionCount] !== null) return this.goToScreen('singleResult');

    return this.goToScreen('start');
};

SeRutQuiz.prototype.initStartScreen = function () {
    var _this31 = this;

    var nextBtnEl = this.screens.start.querySelector('.jsNext');

    nextBtnEl.addEventListener('click', function (e) {
        e.preventDefault();

        // Check if the name is given
        if (_this31.inputP1NameEl.value === '') {
            alert('Vul eerst je naam in om door te gaan.');
            return;
        }

        // Save the names to the data object
        _this31.urlData.name = _this31.capitalizeFirstLetter(_this31.inputP1NameEl.value);

        // Scroll to the section
        var bounds = _this31.parentSection.getBoundingClientRect();
        vanillaSmoothie.scrollTo(bounds.top + window.scrollY - _this31.getResponsiveTopOffset(), { easing: 'easeInOutQuad' });

        // Go to the questions screen
        _this31.goToScreen('questions');
    });
};

SeRutQuiz.prototype.initSingleResultScreen = function () {
    var _this32 = this;

    if (!this.screens.singleResult.classList.contains('initialized')) {
        var url = new Url();
        var btnWrapperEl = this.screens.singleResult.querySelector('.jsBtnWrapper');

        // If the URL contains shareMultiResult, hide the share button
        if (url.query.shareMultiResult) btnWrapperEl.classList.add('show-single-result');

        this.screens.singleResult.addEventListener('click', function (e) {
            if (e.target.classList.contains('jsFormTrigger')) {
                e.preventDefault();
                _this32.hideBackArrow();

                btnWrapperEl.classList.add('hide');
                _this32.screens.singleResult.querySelector('.jsFormWrapper').classList.add('show');
                _this32.screens.singleResult.querySelector('.jsSubtitle').innerHTML = 'Vertel ons hoe het was:';
            }
        });

        this.screens.singleResult.classList.add('initialized');
    }

    this.updateMultiResultsScreen();
};

SeRutQuiz.prototype.updateMultiResultsScreen = function () {
    // Check if all questions have been answered
    if (this.urlData['a' + (this.questionCount - 1)] === null) return;

    var topicListEl = this.screens.singleResult.querySelector('.jsTopicList');
    topicListEl.innerHTML = '';

    // Set the title
    var titleEl = this.screens.singleResult.querySelector('.jsTitle');
    titleEl.innerHTML = this.replaceVariablesInString(this.getSingleResultSentence());
};

SeRutQuiz.prototype.calculateCurrentUserScore = function () {
    var score = 0;

    for (var i = 0; i < this.questionCount; i++) {
        var answerIndex = this.urlData['a' + (i + 1)];
        if (typeof answerIndex !== 'undefined' && answerIndex !== null) score += parseInt(this.questions[i].answers[answerIndex].score);
    }

    return score;
};

SeRutQuiz.prototype.getSingleResultIndex = function () {
    var score = this.calculateCurrentUserScore();

    for (var i = 0; i < this.summarySentences.length; i++) {
        if (parseInt(this.summarySentences[i].score_start) <= score && parseInt(this.summarySentences[i].score_end) >= score) {
            return i + 1;
        }
    }

    return null;
};

SeRutQuiz.prototype.getSingleResultSentence = function () {
    var resultIndex = this.getSingleResultIndex();
    if (resultIndex === null) return null;

    return this.summarySentences[resultIndex - 1].sentence;
};

SeRutQuiz.prototype.replaceVariablesInString = function (string) {
    var findArray = [];
    var replaceArray = [];

    if (this.urlData['name'] !== null) {
        findArray.push('[naam-speler-1]');
        replaceArray.push(this.urlData['name']);
    }

    if (findArray.length === 0) return;

    return this.bulkStringReplace(string, findArray, replaceArray);
};

SeRutQuiz.prototype.replaceVariablesInStrings = function () {
    var _this33 = this;

    var findArray = [];
    var replaceArray = [];

    if (this.urlData['name'] !== null) {
        findArray.push('[naam-speler-1]');
        replaceArray.push(this.urlData['name']);
    }

    if (findArray.length === 0) return;

    this.replaceStringEls.forEach(function (el) {
        el.innerHTML = _this33.addSpansToString(_this33.bulkStringReplace(el.innerHTML, findArray, replaceArray), '##', ['text-color-green']);
    });
};

SeRutQuiz.prototype.bulkStringReplace = function (str, findArray, replaceArray) {
    var regex = [];
    var map = {};

    for (var i = 0; i < findArray.length; i++) {
        regex.push(findArray[i].replace(/([-[\]{}()*+?.\\^$|#,])/g, '\\$1'));
        map[findArray[i]] = replaceArray[i];
    }

    regex = regex.join('|');

    str = str.replace(new RegExp(regex, 'g'), function (matched) {
        return map[matched];
    });

    return str;
};

SeRutQuiz.prototype.addSpansToString = function (string, delimiter, classes) {
    var odd = true;
    var startSpan = classes ? '<span class="' + classes.join(' ') + '">' : '<span>';

    while (string.indexOf(delimiter) !== -1) {
        var pos = string.indexOf(delimiter);

        string = string.substring(0, pos) + (odd ? startSpan : '</span>') + string.substring(pos + delimiter.length, string.length);
        odd = !odd;
    }

    return string;
};

SeRutQuiz.prototype.setSource = function (source) {
    this.sourceEl.innerHTML = source;
};

SeRutQuiz.prototype.hideSource = function () {
    this.sourceEl.classList.remove('show');
};

SeRutQuiz.prototype.showSource = function () {
    this.sourceEl.classList.add('show');
};

document.addEventListener('DOMContentLoaded', function () {
    var quizEls = document.querySelectorAll('.jsRuqQuiz');
    quizEls.forEach(function (el) {
        return new SeRutQuiz(el);
    });
});

function VideoModal(triggerEl) {
    this.triggerEl = triggerEl;
    this.modal = null;
    this.isInitialized = false;
    this.focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), iframe';
    this.firstFocusableElement = null;
    this.lastFocusableElement = null;
    this.previousActiveElement = null;

    this.addEventListeners();
}

VideoModal.prototype = {
    addEventListeners: function addEventListeners() {
        this.triggerEl.addEventListener('click', this.handleClick.bind(this));
    },

    handleClick: function handleClick(e) {
        e.preventDefault();

        if (!this.isInitialized) {
            this.initializeModal();
            this.isInitialized = true;
        }

        var videoUrl = this.triggerEl.getAttribute('data-video-url');
        var videoId = this.extractVideoId(videoUrl);
        var embedUrl = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1';

        var iframe = this.modal.querySelector('iframe');
        iframe.src = embedUrl;
        iframe.setAttribute('tabindex', '0');
        iframe.setAttribute('title', 'YouTube video player');

        this.modal.classList.add('is-active');
        document.body.classList.add('has-modal-open');

        // Bewaar het element dat focus had voor we de modal openden
        this.previousActiveElement = document.activeElement;

        // Focus beheren
        this.setupFocusTrap();
        this.firstFocusableElement.focus();
    },

    extractVideoId: function extractVideoId(url) {
        var regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|shorts\/)([^#&?]*).*/;
        var match = url.match(regExp);
        return match && match[2].length === 11 ? match[2] : null;
    },

    initializeModal: function initializeModal() {
        this.modal = document.createElement('div');
        this.modal.className = 'video-modal';
        this.modal.setAttribute('role', 'dialog');
        this.modal.setAttribute('aria-labelledby', 'video-modal-title');
        this.modal.setAttribute('aria-modal', 'true');
        this.modal.setAttribute('tabindex', '-1');

        this.modal.innerHTML = '\n            <div class="video-modal__overlay" tabindex="-1"></div>\n            <div class="video-modal__content" role="document">\n                <button class="video-modal__close" aria-label="Sluit video">\n                    <span class="video-modal__close-icon"></span>\n                </button>\n                <div class="video-modal__video-container">\n                    <iframe\n                        width="560"\n                        height="315"\n                        frameborder="0"\n                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"\n                        allowfullscreen\n                        title="Video player"\n                        tabindex="0"\n                    ></iframe>\n                </div>\n            </div>\n        ';

        document.body.appendChild(this.modal);

        // Event listeners voor het sluiten van de modal
        var closeButton = this.modal.querySelector('.video-modal__close');
        var overlay = this.modal.querySelector('.video-modal__overlay');

        closeButton.addEventListener('click', this.closeModal.bind(this));
        overlay.addEventListener('click', this.closeModal.bind(this));
        document.addEventListener('keydown', this.handleKeyDown.bind(this));
    },

    setupFocusTrap: function setupFocusTrap() {
        var _this34 = this;

        var focusableElements = this.modal.querySelectorAll(this.focusableElements);
        this.firstFocusableElement = focusableElements[0];
        this.lastFocusableElement = focusableElements[focusableElements.length - 1];

        // Voorkom dat elementen buiten de modal focus kunnen krijgen
        var allFocusableElements = document.querySelectorAll(this.focusableElements);
        allFocusableElements.forEach(function (el) {
            if (!_this34.modal.contains(el)) {
                el.setAttribute('tabindex', '-1');
            }
        });

        this.modal.addEventListener('keydown', this.handleFocusTrap.bind(this));
    },

    handleFocusTrap: function handleFocusTrap(e) {
        if (e.key !== 'Tab') return;

        var iframe = this.modal.querySelector('iframe');
        var isInIframe = document.activeElement === iframe;

        // Als we in de iframe zijn, laten we de browser de focus beheren
        if (isInIframe) return;

        if (e.shiftKey) {
            if (document.activeElement === this.firstFocusableElement) {
                e.preventDefault();
                this.lastFocusableElement.focus();
            }
        } else {
            if (document.activeElement === this.lastFocusableElement) {
                e.preventDefault();
                this.firstFocusableElement.focus();
            }
        }
    },

    closeModal: function closeModal() {
        var _this35 = this;

        this.modal.classList.remove('is-active');
        document.body.classList.remove('has-modal-open');
        var iframe = this.modal.querySelector('iframe');
        iframe.src = '';
        iframe.removeAttribute('tabindex');

        // Herstel tabindex van alle elementen buiten de modal
        var allFocusableElements = document.querySelectorAll(this.focusableElements);
        allFocusableElements.forEach(function (el) {
            if (!_this35.modal.contains(el)) {
                el.removeAttribute('tabindex');
            }
        });

        // Focus terug naar het vorige element
        if (this.previousActiveElement) {
            this.previousActiveElement.focus();
        } else {
            this.triggerEl.focus();
        }
    },

    handleKeyDown: function handleKeyDown(e) {
        if (e.key === 'Escape' && this.modal.classList.contains('is-active')) {
            this.closeModal();
        }
    }
};

(function () {
    var videoModalTriggerEls = document.querySelectorAll('.jsVideoModalTrigger');
    videoModalTriggerEls.forEach(function (el) {
        return new VideoModal(el);
    });
})();

function PopOutModal(triggerEl) {
    this.triggerEl = triggerEl;
    this.modalId = triggerEl.getAttribute('aria-controls');
    this.modal = this.modalId ? document.getElementById(this.modalId) : null;
    this.focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    this.firstFocusableElement = null;
    this.lastFocusableElement = null;
    this.previousActiveElement = null;
    this.isOpen = false;

    if (!this.modal) return;

    this.addEventListeners();
}

PopOutModal.prototype = {
    addEventListeners: function addEventListeners() {
        var _this36 = this;

        this.triggerEl.addEventListener('click', this.open.bind(this));
        this.triggerEl.addEventListener('keydown', this.handleTriggerKeyDown.bind(this));

        this.modal.addEventListener('click', function (e) {
            if (e.target === _this36.modal || e.target.classList.contains('jsClosePopOut')) {
                e.preventDefault();
                _this36.close();
            }
        });

        this.modal.addEventListener('keydown', this.handleFocusTrap.bind(this));
        document.addEventListener('keydown', this.handleKeyDown.bind(this));
    },

    getFocusableElements: function getFocusableElements() {
        return Array.prototype.slice.call(this.modal.querySelectorAll(this.focusableSelector)).filter(function (el) {
            return !el.hasAttribute('disabled') && el.getAttribute('aria-hidden') !== 'true';
        });
    },

    open: function open(e) {
        if (e) e.preventDefault();
        if (this.isOpen || !this.modal) return;

        this.previousActiveElement = document.activeElement;
        this.modal.hidden = false;
        this.modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('has-modal-open');
        this.isOpen = true;

        var focusableElements = this.getFocusableElements();
        this.firstFocusableElement = focusableElements[0] || this.modal;
        this.lastFocusableElement = focusableElements[focusableElements.length - 1] || this.modal;

        var closeBtn = this.modal.querySelector('.pop-out-modal__close');
        if (closeBtn) closeBtn.focus();else this.firstFocusableElement.focus();
    },

    close: function close() {
        if (!this.isOpen || !this.modal) return;

        this.modal.hidden = true;
        this.modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('has-modal-open');
        this.isOpen = false;

        if (this.previousActiveElement && typeof this.previousActiveElement.focus === 'function') {
            this.previousActiveElement.focus();
        } else {
            this.triggerEl.focus();
        }
    },

    handleFocusTrap: function handleFocusTrap(e) {
        if (!this.isOpen || e.key !== 'Tab') return;

        var focusableElements = this.getFocusableElements();
        if (!focusableElements.length) {
            e.preventDefault();
            this.modal.focus();
            return;
        }

        this.firstFocusableElement = focusableElements[0];
        this.lastFocusableElement = focusableElements[focusableElements.length - 1];

        if (e.shiftKey) {
            if (document.activeElement === this.firstFocusableElement) {
                e.preventDefault();
                this.lastFocusableElement.focus();
            }
        } else {
            if (document.activeElement === this.lastFocusableElement) {
                e.preventDefault();
                this.firstFocusableElement.focus();
            }
        }
    },

    handleTriggerKeyDown: function handleTriggerKeyDown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.open(e);
        }
    },

    handleKeyDown: function handleKeyDown(e) {
        if (e.key === 'Escape' && this.isOpen) this.close();
    }
};

(function () {
    var triggers = document.querySelectorAll('.jsPopOutTrigger');
    triggers.forEach(function (el) {
        return new PopOutModal(el);
    });
})();

(function () {
    var offset = 50;

    function getSlugFromHash(hash) {
        if (!hash || hash === '#') return '';
        var rawSlug = hash.charAt(0) === '#' ? hash.substring(1) : hash;

        try {
            return decodeURIComponent(rawSlug);
        } catch (e) {
            return rawSlug;
        }
    }

    function scrollToAnchorSlug(anchorSlug) {
        if (!anchorSlug) return false;

        var section = document.querySelector('[data-anchor="' + anchorSlug + '"]');
        if (!section || typeof vanillaSmoothie === 'undefined') return false;

        vanillaSmoothie.scrollTo(section.getBoundingClientRect().y + window.scrollY - offset, { duration: 500, easing: 'easeInOutQuad' });
        return true;
    }

    function handleHashScroll() {
        return scrollToAnchorSlug(getSlugFromHash(window.location.hash));
    }

    // On initial load (already works today, but keep it centralized)
    handleHashScroll();

    // When hash changes (e.g. clicking a #link), scroll to matching data-anchor
    window.addEventListener('hashchange', function (_) {
        return handleHashScroll();
    });

    // Intercept in-page # links so they work with data-anchor targets
    document.addEventListener('click', function (e) {
        var linkEl = e.target.closest('a[href^="#"]');
        if (!linkEl) return;

        var href = linkEl.getAttribute('href');
        var anchorSlug = getSlugFromHash(href);
        if (!anchorSlug) return;

        // Only handle anchors that exist as data-anchor.
        if (!document.querySelector('[data-anchor="' + anchorSlug + '"]')) return;

        e.preventDefault();

        if (window.location.hash !== '#' + encodeURIComponent(anchorSlug)) {
            history.pushState(null, '', '#' + encodeURIComponent(anchorSlug));
        }

        scrollToAnchorSlug(anchorSlug);
    });
})();

function ItemSlider(el) {
    this.el = el;
    this.slider = null;
    this.controls = this.el.querySelector('.jsItemSliderControls');
    this.indicator = this.controls.querySelector('.jsItemSliderControlsIndicator');
    this.slides = this.el.querySelector('.jsItemSliderSlides');
    this.slideCount = this.slides.querySelectorAll('.slide').length;

    this.initSlider();
    this.initControls();
}

ItemSlider.prototype.initSlider = function () {
    this.slider = new Flickity(this.slides, {
        imagesLoaded: true,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        adaptiveHeight: true
    });
};

ItemSlider.prototype.initControls = function () {
    var _this37 = this;

    this.controls.addEventListener('click', function (e) {
        if (e.target.tagName.toLowerCase() === 'button') {
            e.preventDefault();

            if (e.target.classList.contains('prev')) _this37.slider.previous();else _this37.slider.next();
        }
    });

    this.indicator.innerHTML = '1/' + this.slideCount;
    this.slider.on('change', function (index) {
        return _this37.indicator.innerHTML = index + 1 + '/' + _this37.slideCount;
    });
};

(function () {
    var itemSliders = document.querySelectorAll('.jsItemSlider') || [];
    for (var i = 0; i < itemSliders.length; i++) {
        new ItemSlider(itemSliders[i]);
    }
})();

(function () {
    var sliders = document.querySelectorAll('.jsItemContainerSlider');

    var _loop3 = function _loop3(i) {
        var _ref;

        var sliderEl = sliders[i];

        // Init the slider
        var slider = new Flickity(sliderEl, (_ref = {
            contain: !sliderEl.classList.contains('ic-plus'),
            prevNextButtons: false,
            pageDots: false,
            imagesLoaded: true
        }, _defineProperty(_ref, 'contain', true), _defineProperty(_ref, 'cellAlign', 'left'), _ref));

        // Init the slide buttons
        sliderEl.parentElement.addEventListener('click', function (e) {
            if (e.target.tagName.toLowerCase() === 'button') {
                e.preventDefault();
                if (e.target.classList.contains('prev')) slider.previous();else slider.next();
            }
        });
    };

    for (var i = 0; i < sliders.length; i++) {
        _loop3(i);
    }
})();

function OfficesMap(el) {
    var _this38 = this;

    this.el = el;
    this.modalEl = null;

    this.el.addEventListener('click', function (e) {
        if (e.target.tagName.toLowerCase() === 'button') _this38.showModal(JSON.parse(e.target.dataset.obj));
    });
}

OfficesMap.prototype.createModal = function () {
    var _this39 = this;

    if (this.modalEl !== null) return;

    this.modalEl = document.createElement('div');
    this.modalEl.classList.add('office-project-modal');
    this.modalEl.classList.add('jsCloseModal');

    var innerEl = document.createElement('div');
    innerEl.classList.add('office-project-modal__inner');
    this.modalEl.appendChild(innerEl);

    innerEl.innerHTML = '' + '<div class="office-project-modal__logo jsLogo"></div>' + '<button class="office-project-modal__close-btn jsCloseModal" type="button">Sluiten</button>' + '<span class="office-project-modal__title jsTitle"></span>' + '<div class="office-project-modal__offices jsOffices">' + '<span class="office-project-modal__subtitle">' + officesNameString + '</span>' + '<ul></ul>' + '</div>' + '<div class="office-project-modal__programs jsPrograms">' + '<span class="office-project-modal__subtitle">' + programsNameString + '</span>' + '<ul></ul>' + '</div>' + '<div class="office-project-modal__item-display jsItemDisplay">' + '<button type="button" class="office-project-modal__back-btn btn btn--arrow-reverse btn--trans btn--medium text-color-black jsBackBtn">' + officeProjectModalBackText + '</button>' + '<span class="office-project-modal__subtitle jsItemDisplaySubtitle">AAA!</span>' + '<span class="office-project-modal__title jsItemDisplayTitle">BBB!!</span>' + '<div class="office-project-modal__address default-styles jsItemDisplayAddress">BBB!!</div>' + '<a href="" target="" class="office-project-modal__cta btn btn--arrow bg-color-purple-1-2 text-color-white jsitemDisplayCta"></a>';
    '</div>';

    document.body.appendChild(this.modalEl);

    // Init event listeners
    this.modalEl.addEventListener('click', function (e) {
        if (e.target.classList.contains('jsCloseModal')) _this39.hideModal();else if (e.target.classList.contains('jsShowItem')) _this39.showItem(e.target);else if (e.target.classList.contains('jsBackBtn')) {
            var itemDisplayEl = _this39.modalEl.querySelector('.jsItemDisplay');
            var titleEl = _this39.modalEl.querySelector('.jsTitle');
            var officesEl = _this39.modalEl.querySelector('.jsOffices');
            var programsEl = _this39.modalEl.querySelector('.jsPrograms');
            var logoEl = _this39.modalEl.querySelector('.jsLogo');

            itemDisplayEl.style.display = 'none';
            titleEl.style.display = '';
            officesEl.style.display = '';
            programsEl.style.display = '';
            logoEl.innerHTML = '';
        }
    });

    window.addEventListener('keyup', function (e) {
        if (e.key.toLowerCase() === 'escape') _this39.hideModal();
    });
};

OfficesMap.prototype.showModal = function (data) {
    this.createModal();

    var itemDisplayEl = this.modalEl.querySelector('.jsItemDisplay');
    var titleEl = this.modalEl.querySelector('.jsTitle');
    var officesEl = this.modalEl.querySelector('.jsOffices');
    var programsEl = this.modalEl.querySelector('.jsPrograms');

    data.offices = Object.values(data.offices);
    data.programs = Object.values(data.programs);

    itemDisplayEl.style.display = '';
    titleEl.innerHTML = data.title;

    // Show the offices
    if (data.offices.length > 0) {
        var ulEl = officesEl.querySelector('ul');

        ulEl.innerHTML = '';
        data.offices.forEach(function (office) {
            return ulEl.innerHTML += "<li><button type='button' class='jsShowItem' data-obj='" + JSON.stringify(office) + "'>" + office.title + "</button></li>";
        });
        officesEl.style.display = '';
    } else {
        officesEl.style.display = 'none';
    }

    // Show the programs
    if (data.programs.length > 0) {
        var _ulEl = programsEl.querySelector('ul');

        _ulEl.innerHTML = '';
        data.programs.forEach(function (program) {
            return _ulEl.innerHTML += '<li><a href="' + program.url + '">' + program.title + '</a></li>';
        });
        programsEl.style.display = '';
    } else {
        programsEl.style.display = 'none';
    }

    document.body.classList.add('no-overflow');
    this.modalEl.classList.add('visible');
};

OfficesMap.prototype.hideModal = function () {
    this.modalEl.classList.remove('visible');
    document.body.classList.remove('no-overflow');
};

OfficesMap.prototype.showItem = function (itemEl) {
    var data = JSON.parse(itemEl.dataset.obj);

    var itemDisplayEl = this.modalEl.querySelector('.jsItemDisplay');
    var itemDisplaySubtitleEl = itemDisplayEl.querySelector('.jsItemDisplaySubtitle');
    var itemDisplayTitleEl = itemDisplayEl.querySelector('.jsItemDisplayTitle');
    var itemDisplayAddressEl = itemDisplayEl.querySelector('.jsItemDisplayAddress');
    var itemDisplayCtaEl = itemDisplayEl.querySelector('.jsitemDisplayCta');
    var titleEl = this.modalEl.querySelector('.jsTitle');
    var officesEl = this.modalEl.querySelector('.jsOffices');
    var programsEl = this.modalEl.querySelector('.jsPrograms');
    var logoEl = this.modalEl.querySelector('.jsLogo');

    // Insert the content
    itemDisplaySubtitleEl.innerHTML = data.type == 'program' ? programNameString : officeNameString;
    itemDisplayTitleEl.innerHTML = data.title;

    itemDisplayAddressEl.innerHTML = data.type === 'program' ? data.country : data.address + '<br/>' + data.zipcode_location + '<br/>' + data.office_country;
    itemDisplayAddressEl.innerHTML = '<p>' + itemDisplayAddressEl.innerHTML + '</p>';

    // Set the CTA-button
    if (data.btn !== '') {
        itemDisplayCtaEl.style.display = '';
        itemDisplayCtaEl.innerHTML = data.btn.title;
        itemDisplayCtaEl.href = data.btn.url;
        itemDisplayCtaEl.target = data.btn.target;
    } else {
        itemDisplayCtaEl.style.display = 'none';
    }

    // Show the logo
    logoEl.innerHTML = '';
    if (data.logo) logoEl.innerHTML = '<img src="' + data.logo + '" alt="' + data.title + '" />';

    // Show/hide the correct items
    itemDisplayEl.style.display = 'block';
    titleEl.style.display = 'none';
    officesEl.style.display = 'none';
    programsEl.style.display = 'none';
};

(function () {
    var map = document.querySelector('.jsOfficesMap');
    if (map) new OfficesMap(map);
})();

(function () {
    var imageSliders = document.querySelectorAll('.jsImageSlider');

    var _loop4 = function _loop4(i) {
        var slideCount = imageSliders[i].querySelectorAll('img').length;
        if (slideCount > 1) {
            imageSliders[i].classList.add('first');

            new Flickity(imageSliders[i], {
                prevNextButtons: true,
                pageDots: true,
                on: {
                    change: function change(index) {
                        imageSliders[i].classList.remove('first');
                        imageSliders[i].classList.remove('last');

                        if (index === 0) imageSliders[i].classList.add('first');else if (index === slideCount - 1) imageSliders[i].classList.add('last');
                    }
                }
            });
        }
    };

    for (var i = 0; i < imageSliders.length; i++) {
        _loop4(i);
    }
})();

function BulletSlider(el) {
    new Flickity(el, {
        prevNextButtons: false,
        adaptiveHeight: true,
        pageDots: true
    });
}

(function () {
    var bulletSliderEls = document.querySelectorAll('.jsBulletSlider');
    [].concat(_toConsumableArray(bulletSliderEls)).map(function (el) {
        return new BulletSlider(el);
    });
})();

function TextSlider(el) {
    new Flickity(el, {
        prevNextButtons: true,
        pageDots: false,
        wrapAround: true,
        autoPlay: 5000,
        adaptiveHeight: false,
        cellAlign: 'left'
    });
}

(function () {
    var textSliderEls = document.querySelectorAll('.jsTextSlider');
    [].concat(_toConsumableArray(textSliderEls)).map(function (el) {
        return new TextSlider(el);
    });
})();

function PartnerCollaboratorsSlider(el) {
    var _this40 = this;

    this.el = el;
    this.partnerEls = this.el.querySelectorAll('li');
    this.partnerElQueue = [].concat(_toConsumableArray(this.el.querySelectorAll('li.hidden')));
    this.nextIndex = 0;

    // Start the interval when there are more than 6 partners
    if (this.partnerEls.length > 6) setInterval(function (_) {
        return _this40.pickRandomVisibleEl();
    }, 3000);
}

PartnerCollaboratorsSlider.prototype.pickRandomVisibleEl = function () {
    var nextItemEl = this.partnerElQueue.shift();
    var currentItemEl = this.partnerEls[this.nextIndex];
    var currentItemClone = currentItemEl.cloneNode(true);

    // Add the cloned element to the end of the queue
    currentItemClone.classList.remove('visible');
    currentItemClone.classList.add('hidden');
    this.partnerElQueue.push(currentItemClone);

    // Replace the next item with the current item
    gsap.timeline().to(currentItemEl, 0.5, { opacity: 0, ease: Power2.inOut }).add(function (_) {
        return currentItemEl.innerHTML = nextItemEl.innerHTML;
    }).to(currentItemEl, 0.5, { opacity: 1, ease: Power2.inOut });

    this.nextIndex++;
    if (this.nextIndex > 5) this.nextIndex = 0;
};

(function () {
    var sliders = document.querySelectorAll('.jsPartnersCollaborators');
    [].concat(_toConsumableArray(sliders)).forEach(function (el) {
        return new PartnerCollaboratorsSlider(el);
    });
})();
(function () {
    var bulletPrefix = '⚪ ';
    var indentEm = 1.5;
    var shy = '\xAD';
    var bulletWidthFactors = [1, 0.9, 0.8, 0.7];

    function bulletWidthFactor(bulletIndex) {
        return bulletWidthFactors[bulletIndex] !== undefined ? bulletWidthFactors[bulletIndex] : 0.7;
    }

    function buildUnits(text) {
        var units = [];

        text.split(' ').forEach(function (word, wordIndex) {
            word.split(shy).forEach(function (part, partIndex) {
                if (wordIndex === 0 && partIndex === 0) units.push({ text: part, breakBefore: null });else if (partIndex === 0) units.push({ text: part, breakBefore: 'space' });else units.push({ text: part, breakBefore: 'shy' });
            });
        });

        return units;
    }

    function measureTextWidth(textEl, text) {
        var tspan = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
        tspan.textContent = text;
        textEl.appendChild(tspan);
        var width = tspan.getBBox().width;
        textEl.removeChild(tspan);
        return width;
    }

    function wrapSvgText(textEl, text, firstLineMaxWidth, continuationMaxWidth) {
        var units = buildUnits(text);
        var lines = [];
        var current = '';

        units.forEach(function (unit) {
            var maxWidth = lines.length === 0 ? firstLineMaxWidth : continuationMaxWidth;

            if (current === '') {
                current = unit.text;
                return;
            }

            if (unit.breakBefore === 'space') {
                var candidate = current + ' ' + unit.text;
                if (measureTextWidth(textEl, candidate) <= maxWidth) current = candidate;else {
                    lines.push(current);
                    current = unit.text;
                }
                return;
            }

            var joined = current + unit.text;
            if (measureTextWidth(textEl, joined) <= maxWidth) current = joined;else {
                lines.push(current + '-');
                current = unit.text;
            }
        });

        if (current !== '') lines.push(current);

        return lines;
    }

    function parseBullets(textEl) {
        var bullets = [];
        var currentBullet = '';

        textEl.querySelectorAll('tspan').forEach(function (tspan) {
            var text = tspan.textContent;

            if (text.startsWith(bulletPrefix)) {
                if (currentBullet !== '') bullets.push(currentBullet.trim());
                currentBullet = text.slice(bulletPrefix.length);
            } else currentBullet += ' ' + text.trim();
        });

        if (currentBullet !== '') bullets.push(currentBullet.trim());

        return bullets;
    }

    function renderBullets(textEl, bullets, x, maxWidth, taper) {
        var prefixWidth = measureTextWidth(textEl, bulletPrefix);
        var fontSize = parseFloat(getComputedStyle(textEl).fontSize) || 16.8;
        var indentWidth = fontSize * indentEm;

        textEl.textContent = '';

        var isFirst = true;

        bullets.forEach(function (bullet, bulletIndex) {
            var bulletMaxWidth = taper ? maxWidth * bulletWidthFactor(bulletIndex) : maxWidth;
            var lines = wrapSvgText(textEl, bullet, bulletMaxWidth - prefixWidth, bulletMaxWidth - indentWidth);

            lines.forEach(function (line, lineIndex) {
                var tspan = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
                tspan.setAttribute('x', x);

                if (lineIndex === 0) {
                    if (!isFirst) tspan.setAttribute('dy', '1.4em');
                    tspan.textContent = bulletPrefix + line;
                    isFirst = false;
                } else {
                    tspan.setAttribute('dx', indentEm + 'em');
                    tspan.setAttribute('dy', '1.2em');
                    tspan.textContent = line;
                }

                textEl.appendChild(tspan);
            });
        });
    }

    function reflowCirkeltext(textEl) {
        var maxWidth = parseFloat(textEl.dataset.maxWidth);
        var taper = textEl.dataset.taper === '1';
        var firstTspan = textEl.querySelector('tspan');
        var x = textEl.getAttribute('x') || (firstTspan ? firstTspan.getAttribute('x') : null);

        if (!maxWidth || !x) return;

        var bullets = parseBullets(textEl);
        if (!bullets.length) return;

        renderBullets(textEl, bullets, x, maxWidth, taper);
    }

    function reflowAll() {
        document.querySelectorAll('.c-interactive-disc .cirkeltext[data-max-width]').forEach(reflowCirkeltext);
    }

    var resizeTimer = void 0;

    function init() {
        reflowAll();
        window.addEventListener('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(reflowAll, 150);
        });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);else init();
})();

function AccordionComponent(el) {
    this.el = el;
    this.init();
}

AccordionComponent.prototype.init = function () {
    var _this41 = this;

    this.el.addEventListener('click', function (e) {
        if (e.target.classList.contains('jsTitle')) {
            _this41.toggleLine(e.target.parentElement);
        }
    });
};

AccordionComponent.prototype.toggleLine = function (lineEl) {
    if (lineEl.classList.contains('open')) {
        this.closeLine(lineEl);
    } else {
        this.closeAllLines();
        this.openLine(lineEl);
    }
};

AccordionComponent.prototype.openLine = function (lineEl) {
    var contentEl = lineEl.querySelector('.jsContent');

    lineEl.classList.add('open');
    var newContentHeight = contentEl.offsetHeight;
    lineEl.classList.remove('open');

    gsap.timeline().set(contentEl, { height: 0 }).add(function () {
        return lineEl.classList.add('open');
    }).to(contentEl, { duration: 0.5, height: newContentHeight, ease: 'power2.inOut' }).set(contentEl, { clearProps: 'all' });
};

AccordionComponent.prototype.closeLine = function (lineEl) {
    var contentEl = lineEl.querySelector('.jsContent');

    gsap.timeline().to(contentEl, { duration: 0.5, height: 0, ease: 'power2.inOut' }).add(function () {
        return lineEl.classList.remove('open');
    }).set(contentEl, { clearProps: 'all' });
};

AccordionComponent.prototype.closeAllLines = function () {
    var lineEls = this.el.querySelectorAll('.jsLine.open');
    for (var i = 0; i < lineEls.length; i++) {
        this.closeLine(lineEls[i]);
    }
};

(function () {
    var accordionEls = document.querySelectorAll('.jsAccordionComponent');
    for (var i = 0; i < accordionEls.length; i++) {
        new AccordionComponent(accordionEls[i]);
    }
})();
function SourcesComponent(el) {
    this.el = el;
    this.toggleEl = el.querySelector('.jsSourcesToggle');
    this.panelEl = el.querySelector('.jsSourcesPanel');
    this.isOpen = false;
    this.init();
}

SourcesComponent.prototype.init = function () {
    var _this42 = this;

    this.toggleEl.addEventListener('click', function () {
        return _this42.toggle();
    });
};

SourcesComponent.prototype.openInstant = function (onComplete) {
    gsap.killTweensOf(this.panelEl);
    gsap.set(this.panelEl, { clearProps: 'all' });
    this.el.classList.add('is-open');
    this.isOpen = true;
    this.toggleEl.setAttribute('aria-expanded', 'true');

    if (!onComplete) return;

    requestAnimationFrame(function () {
        requestAnimationFrame(onComplete);
    });
};

SourcesComponent.prototype.open = function (onComplete, animate) {
    var _this43 = this;

    if (animate === false) {
        this.openInstant(onComplete);
        return;
    }

    if (this.isOpen) {
        if (onComplete) onComplete();
        return;
    }

    this.el.classList.add('is-open');
    var newContentHeight = this.panelEl.scrollHeight;
    this.el.classList.remove('is-open');

    gsap.timeline().set(this.panelEl, { height: 0 }).add(function () {
        _this43.el.classList.add('is-open');
        _this43.isOpen = true;
        _this43.toggleEl.setAttribute('aria-expanded', 'true');
    }).to(this.panelEl, { duration: 0.5, height: newContentHeight, ease: 'power2.inOut' }).set(this.panelEl, { clearProps: 'all' }).add(function () {
        if (onComplete) onComplete();
    });
};

SourcesComponent.prototype.close = function () {
    var _this44 = this;

    if (!this.isOpen) return;

    gsap.timeline().to(this.panelEl, { duration: 0.5, height: 0, ease: 'power2.inOut' }).add(function () {
        _this44.el.classList.remove('is-open');
        _this44.isOpen = false;
        _this44.toggleEl.setAttribute('aria-expanded', 'false');
    }).set(this.panelEl, { clearProps: 'all' });
};

SourcesComponent.prototype.toggle = function () {
    if (this.isOpen) this.close();else this.open();
};

(function () {
    var bronHashPattern = /^#bron-(\d+)$/;
    var instances = [];

    function getScrollOffset() {
        var baseOffset = 20;
        var headerEl = document.querySelector('.header');

        if (!headerEl) return 50;

        var headerStyle = window.getComputedStyle(headerEl);

        if (headerStyle.position === 'fixed' || headerStyle.position === 'sticky') {
            return headerEl.getBoundingClientRect().bottom + baseOffset;
        }

        return 50;
    }

    function getSlugFromHash(hash) {
        if (!hash || hash === '#') return '';
        var rawSlug = hash.charAt(0) === '#' ? hash.substring(1) : hash;

        try {
            return decodeURIComponent(rawSlug);
        } catch (e) {
            return rawSlug;
        }
    }

    function getBronTarget(hash) {
        var slug = getSlugFromHash(hash);
        if (!slug || !slug.match(/^bron-\d+$/)) return null;
        return document.getElementById(slug);
    }

    function scrollToSourcesBlock(sourcesEl) {
        if (!sourcesEl || typeof vanillaSmoothie === 'undefined') return;

        var scrollTarget = sourcesEl.querySelector('.jsSourcesToggle') || sourcesEl;

        requestAnimationFrame(function () {
            vanillaSmoothie.scrollTo(scrollTarget.getBoundingClientRect().top + window.scrollY - getScrollOffset(), { duration: 500, easing: 'easeInOutQuad' });
        });
    }

    function getInstanceForTarget(targetEl) {
        var sourcesEl = targetEl.closest('.jsSourcesComponent');
        if (!sourcesEl) return null;

        for (var i = 0; i < instances.length; i++) {
            if (instances[i].el === sourcesEl) return instances[i];
        }

        return null;
    }

    function expandAndScrollToHash(hash) {
        var targetEl = getBronTarget(hash);
        if (!targetEl) return false;

        var instance = getInstanceForTarget(targetEl);
        if (!instance) return false;

        instance.open(function () {
            return scrollToSourcesBlock(instance.el);
        }, false);
        return true;
    }

    function handleBronHash(hash) {
        return expandAndScrollToHash(hash);
    }

    var sourcesEls = document.querySelectorAll('.jsSourcesComponent');
    for (var i = 0; i < sourcesEls.length; i++) {
        instances.push(new SourcesComponent(sourcesEls[i]));
    }if (window.location.hash && bronHashPattern.test(window.location.hash) && 'scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
    }

    document.addEventListener('click', function (e) {
        var linkEl = e.target.closest('.c-sources-ref__link');
        if (!linkEl) return;

        var href = linkEl.getAttribute('href');
        if (!href || !bronHashPattern.test(href)) return;

        e.preventDefault();

        if (window.location.hash !== href) history.pushState(null, '', href);

        handleBronHash(href);
    });

    if (window.location.hash) handleBronHash(window.location.hash);

    window.addEventListener('hashchange', function () {
        if (window.location.hash) handleBronHash(window.location.hash);
    });
})();

function PetitionResults(el) {
    this.el = el;
    this.postId = el.dataset.postId;
    this.searchInput = el.querySelector('.jsPetitionResultsSearch');
    this.resultsList = el.querySelector('.jsPetitionResultsList');
    this.paginationContainers = el.querySelectorAll('.jsPetitionResultsPagination');
    this.currentPage = 1;
    this.searchQuery = '';
    this.searchTimeout = null;
    this.maxPages = parseInt(el.dataset.maxPages) || 1;

    this.init();
}

PetitionResults.prototype.init = function () {
    var _this45 = this;

    if (this.searchInput) {
        this.searchInput.addEventListener('keyup', function (e) {
            _this45.handleSearch(e.target.value);
        });
    }

    this.setupPagination();
    this.updatePaginationVisibility();

    // Get current page from existing pagination if available
    var currentPageEl = this.el.querySelector('.page-numbers.current');
    if (currentPageEl) {
        var page = parseInt(currentPageEl.textContent);
        if (page && !isNaN(page)) {
            this.currentPage = page;
        }
    }

    // Load initial results via AJAX to ensure correct data
    this.loadResults();
};

PetitionResults.prototype.handleSearch = function (query) {
    var _this46 = this;

    this.searchQuery = query.trim();

    if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
    }

    this.searchTimeout = setTimeout(function () {
        _this46.currentPage = 1;
        _this46.loadResults();
    }, 200);
};

PetitionResults.prototype.setupPagination = function () {
    var _this47 = this;

    this.paginationContainers.forEach(function (container) {
        container.addEventListener('click', function (e) {
            var target = e.target;
            if (!target.classList.contains('page-numbers') || target.classList.contains('current')) {
                return;
            }

            if (target.classList.contains('next')) {
                if (_this47.currentPage < _this47.maxPages) {
                    _this47.currentPage++;
                    _this47.loadResults(true);
                }
            } else {
                var pageNumber = parseInt(target.textContent);
                if (pageNumber && pageNumber !== _this47.currentPage) {
                    _this47.currentPage = pageNumber;
                    _this47.loadResults(true);
                }
            }
        });
    });
};

PetitionResults.prototype.loadResults = function (isPagination) {
    var _this48 = this;

    var params = {
        action: 'se_get_petition_results',
        postId: this.postId,
        pageNumber: this.currentPage,
        searchQuery: this.searchQuery
    };

    se_postRequest(se_ajax.ajaxurl, params, function (response) {
        try {
            var data = JSON.parse(response);

            if (data.err) {
                console.error('Error loading petition results:', data.err);
                return;
            }

            _this48.maxPages = data.max_num_pages || 1;
            _this48.currentPage = data.current_page || 1;

            if (_this48.resultsList) {
                var header = _this48.resultsList.querySelector('.result-header');
                _this48.resultsList.innerHTML = '';
                if (header) {
                    _this48.resultsList.appendChild(header);
                }
                _this48.resultsList.insertAdjacentHTML('beforeend', data.html);
            }

            _this48.paginationContainers.forEach(function (container) {
                container.innerHTML = data.pagination || '';
            });

            _this48.updatePaginationVisibility();

            if (isPagination) {
                _this48.scrollToElementIfOutOfView();
            }
        } catch (error) {
            console.error('Error parsing response:', error);
        }
    }, function () {
        console.error('Error loading petition results');
    });
};

PetitionResults.prototype.updatePaginationVisibility = function () {
    var _this49 = this;

    this.paginationContainers.forEach(function (container) {
        if (_this49.maxPages < 2) {
            container.style.display = 'none';
        } else {
            container.style.display = '';
        }
    });
};

PetitionResults.prototype.isElementOutOfView = function () {
    var rect = this.el.getBoundingClientRect();
    return rect.top < 0;
};

PetitionResults.prototype.scrollToElementIfOutOfView = function () {
    if (this.isElementOutOfView()) {
        var elementTop = this.el.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
            top: elementTop,
            behavior: 'smooth'
        });
    }
};

(function () {
    var petitionResultsEls = document.querySelectorAll('.jsPetitionResults') || [];
    for (var i = 0; i < petitionResultsEls.length; i++) {
        new PetitionResults(petitionResultsEls[i]);
    }
})();

(function () {
    var archiveEl = document.body.querySelector('.jsArchive');
    var archiveGrid = null;
    var currentPage = 1;
    var searchTimeout = null;
    var searchQuery = '';
    var postType = 'post';

    if (archiveEl) {
        postType = typeof archiveEl.dataset.postType !== 'undefined' ? archiveEl.dataset.postType : 'post';
        archiveGrid = archiveEl.querySelector('.jsArchiveGrid');

        var contentTypeFilterEl = archiveEl.querySelector('.jsContentTypeFilter');
        if (contentTypeFilterEl) {
            var contentTypeSelect = new SeSelect(contentTypeFilterEl, 'type');
            contentTypeSelect.setActiveOptions(activeContentTypes);

            contentTypeSelect.addChangeEventListener(function (newOptions) {
                activeContentTypes = Object.keys(newOptions);
                currentPage = 1;
                updateGrid();
            });
        }

        var yearFilterEl = archiveEl.querySelector('.jsYearFilter');
        if (yearFilterEl) {
            var yearSelect = new SeSelect(yearFilterEl, 'y');
            yearSelect.setActiveOptions(activeYears);

            yearSelect.addChangeEventListener(function (newOptions) {
                activeYears = Object.keys(newOptions);
                currentPage = 1;
                updateGrid();
            });
        }

        var themeFilterEl = archiveEl.querySelector('.jsThemeFilter');
        if (themeFilterEl) {
            var themeSelect = new SeSelect(themeFilterEl, 'theme');
            themeSelect.setActiveOptions(activeThemes);

            themeSelect.addChangeEventListener(function (newOptions) {
                activeThemes = Object.keys(newOptions);
                currentPage = 1;
                updateGrid();
            });
        }

        var programFilterEl = archiveEl.querySelector('.jsProgramFilter');
        if (programFilterEl) {
            var programSelect = new SeSelect(programFilterEl, 'program');
            programSelect.setActiveOptions(activePrograms);

            programSelect.addChangeEventListener(function (newOptions) {
                activePrograms = Object.keys(newOptions);
                currentPage = 1;
                updateGrid();
            });
        }

        var searchFormEl = archiveEl.querySelector('.jsSearchFilter');
        if (searchFormEl) {
            var searchInputEl = searchFormEl.querySelector('input');

            searchFormEl.addEventListener('submit', function (e) {
                e.preventDefault();
                userDidSearch(searchInputEl.value);
            });

            searchInputEl.addEventListener('keyup', function (e) {
                e.preventDefault();
                userDidSearch(searchInputEl.value);
            });
        }
    }

    function userDidSearch(query) {
        searchQuery = query;

        // Update the URL
        var url = new Url();

        if (searchQuery) url.query.search = searchQuery;else delete url.query.search;

        history.pushState(null, null, url.toString());

        // Set a timeout
        if (searchTimeout) clearTimeout(searchTimeout);
        searchTimeout = setTimeout(function (_) {
            return updateGrid();
        }, 500);
    }

    function updateGrid() {
        var params = {
            action: 'get_story_grid_html',
            activeContentTypes: activeContentTypes,
            searchQuery: searchQuery,
            pageNumber: currentPage,
            baseUrl: archiveUrl + window.location.search,
            postType: postType
        };

        if (typeof activeYears !== 'undefined') params.activeYears = activeYears;
        if (typeof activeThemes !== 'undefined') params.activeThemes = activeThemes;
        if (typeof activePrograms !== 'undefined') params.activePrograms = activePrograms;

        se_postRequest(se_ajax.ajaxurl, params, function (response) {
            response = JSON.parse(response);

            if (!response.err) {
                archiveGrid.innerHTML = response.html;
            } else {
                alert('Oops.. Something went wrong. Please reload the page and try again.');
                return;
            }
        }, function (_) {
            alert('Oops.. Something went wrong. Please reload the page and try again.');
            return;
        });
    }
})();

(function () {
    var archiveEl = document.body.querySelector('.jsResearchArchive');
    var archiveGrid = null;
    var currentPage = 1;
    var searchTimeout = null;
    var searchQuery = '';
    var postType = 'rut_research';

    if (archiveEl) {
        postType = typeof archiveEl.dataset.postType !== 'undefined' ? archiveEl.dataset.postType : 'post';
        archiveGrid = archiveEl.querySelector('.jsArchiveGrid');

        var themeFilterEl = archiveEl.querySelector('.jsThemeFilter');
        if (themeFilterEl) {
            var themeSelect = new SeSelect(themeFilterEl, 'theme');
            themeSelect.setActiveOptions(activeThemes);

            themeSelect.addChangeEventListener(function (newOptions) {
                activeThemes = Object.keys(newOptions);
                currentPage = 1;
                updateGrid();
            });
        }

        var targetGroupFilterEl = archiveEl.querySelector('.jsTargetGroupFilter');
        if (targetGroupFilterEl) {
            var targetGroupSelect = new SeSelect(targetGroupFilterEl, 'target-group');
            targetGroupSelect.setActiveOptions(activeTargetGroups);

            targetGroupSelect.addChangeEventListener(function (newOptions) {
                activeTargetGroups = Object.keys(newOptions);
                currentPage = 1;
                updateGrid();
            });
        }

        var typeFilterEl = archiveEl.querySelector('.jsTypeFilter');
        if (typeFilterEl) {
            var typeSelect = new SeSelect(typeFilterEl, 'type');
            typeSelect.setActiveOptions(activeTypes);

            typeSelect.addChangeEventListener(function (newOptions) {
                activeTypes = Object.keys(newOptions);
                currentPage = 1;
                updateGrid();
            });
        }

        var searchFormEl = archiveEl.querySelector('.jsSearchFilter');
        if (searchFormEl) {
            var searchInputEl = searchFormEl.querySelector('input');

            searchFormEl.addEventListener('submit', function (e) {
                e.preventDefault();
                userDidSearch(searchInputEl.value);
            });

            searchInputEl.addEventListener('keyup', function (e) {
                e.preventDefault();
                userDidSearch(searchInputEl.value);
            });
        }
    }

    function userDidSearch(query) {
        searchQuery = query;

        // Update the URL
        var url = new Url();

        if (searchQuery) url.query.search = searchQuery;else delete url.query.search;

        history.pushState(null, null, url.toString());

        // Set a timeout
        if (searchTimeout) clearTimeout(searchTimeout);
        searchTimeout = setTimeout(function (_) {
            return updateGrid();
        }, 500);
    }

    function updateGrid() {
        var params = {
            action: 'get_story_grid_html',
            searchQuery: searchQuery,
            pageNumber: currentPage,
            baseUrl: archiveUrl + window.location.search,
            postType: postType
        };

        if (typeof activeThemes !== 'undefined') params.activeThemes = activeThemes;
        if (typeof activeTargetGroups !== 'undefined') params.activeTargetGroups = activeTargetGroups;
        if (typeof activeTypes !== 'undefined') params.activeTypes = activeTypes;

        se_postRequest(se_ajax.ajaxurl, params, function (response) {
            response = JSON.parse(response);

            if (!response.err) {
                archiveGrid.innerHTML = response.html;
            } else {
                alert('Oops.. Something went wrong. Please reload the page and try again.');
                return;
            }
        }, function (_) {
            alert('Oops.. Something went wrong. Please reload the page and try again.');
            return;
        });
    }
})();

(function () {
    var archiveEl = document.querySelector('.jsDownloadArchive');
    var archiveGrid = null;
    var searchTimeout = null;
    var searchQuery = '';

    if (archiveEl) {
        archiveGrid = archiveEl.querySelector('.jsArchiveGrid');

        var downloadTypeFilterEl = archiveEl.querySelector('.jsDownloadTypeFilter');
        if (downloadTypeFilterEl) {
            var downloadTypeSelect = new SeSelect(downloadTypeFilterEl, 'type');
            downloadTypeSelect.setActiveOptions(activeDownloadTypes);

            downloadTypeSelect.addChangeEventListener(function (newOptions) {
                activeDownloadTypes = Object.keys(newOptions);
                updateGrid();
            });
        }

        var themeFilterEl = archiveEl.querySelector('.jsThemeFilter');
        if (themeFilterEl) {
            var themeSelect = new SeSelect(themeFilterEl, 'theme');
            themeSelect.setActiveOptions(activeThemes);

            themeSelect.addChangeEventListener(function (newOptions) {
                activeThemes = Object.keys(newOptions);
                updateGrid();
            });
        }

        var programFilterEl = archiveEl.querySelector('.jsProgramFilter');
        if (programFilterEl) {
            var programSelect = new SeSelect(programFilterEl, 'program');
            programSelect.setActiveOptions(activePrograms);

            programSelect.addChangeEventListener(function (newOptions) {
                activePrograms = Object.keys(newOptions);
                updateGrid();
            });
        }

        var searchFormEl = archiveEl.querySelector('.jsSearchFilter');
        if (searchFormEl) {
            var searchInputEl = searchFormEl.querySelector('input');

            searchFormEl.addEventListener('submit', function (e) {
                e.preventDefault();
                userDidSearch(searchInputEl.value);
            });

            searchInputEl.addEventListener('keyup', function (e) {
                e.preventDefault();
                userDidSearch(searchInputEl.value);
            });
        }
    }

    function userDidSearch(query) {
        searchQuery = query;

        // Update the URL
        var url = new Url();

        if (searchQuery) url.query.search = searchQuery;else delete url.query.search;

        history.pushState(null, null, url.toString());

        // Set a timeout
        if (searchTimeout) clearTimeout(searchTimeout);
        searchTimeout = setTimeout(function (_) {
            return updateGrid();
        }, 500);
    }

    function updateGrid() {
        var params = {
            action: 'get_download_grid_html',
            activeDownloadTypes: activeDownloadTypes,
            activeThemes: activeThemes,
            activePrograms: activePrograms,
            searchQuery: searchQuery
        };

        if (typeof activeYears !== 'undefined') params.activeYears = activeYears;
        if (typeof activeThemes !== 'undefined') params.activeThemes = activeThemes;
        if (typeof activePrograms !== 'undefined') params.activePrograms = activePrograms;

        se_postRequest(se_ajax.ajaxurl, params, function (response) {
            response = JSON.parse(response);

            if (!response.err) {
                archiveGrid.innerHTML = response.html;
            } else {
                alert('Oops.. Something went wrong. Please reload the page and try again.');
                return;
            }
        }, function (_) {
            alert('Oops.. Something went wrong. Please reload the page and try again.');
            return;
        });
    }
})();

(function () {
    var archiveEl = document.querySelector('.jsTipToolArchive');
    var archiveGrid = null;
    var searchTimeout = null;
    var searchQuery = '';

    if (archiveEl) {
        archiveGrid = archiveEl.querySelector('.jsArchiveGrid');

        var typeFilterEl = archiveEl.querySelector('.jsTypeFilter');
        if (typeFilterEl) {
            var typeSelect = new SeSelect(typeFilterEl, 'type');
            typeSelect.setActiveOptions(activeTypes);

            typeSelect.addChangeEventListener(function (newOptions) {
                activeTypes = Object.keys(newOptions);
                updateGrid();
            });
        }

        var themeFilterEl = archiveEl.querySelector('.jsThemeFilter');
        if (themeFilterEl) {
            var themeSelect = new SeSelect(themeFilterEl, 'theme');
            themeSelect.setActiveOptions(activeThemes);

            themeSelect.addChangeEventListener(function (newOptions) {
                activeThemes = Object.keys(newOptions);
                updateGrid();
            });
        }

        var searchFormEl = archiveEl.querySelector('.jsSearchFilter');
        if (searchFormEl) {
            var searchInputEl = searchFormEl.querySelector('input');

            searchFormEl.addEventListener('submit', function (e) {
                e.preventDefault();
                userDidSearch(searchInputEl.value);
            });

            searchInputEl.addEventListener('keyup', function (e) {
                e.preventDefault();
                userDidSearch(searchInputEl.value);
            });
        }
    }

    function userDidSearch(query) {
        searchQuery = query;

        // Update the URL
        var url = new Url();

        if (searchQuery) url.query.search = searchQuery;else delete url.query.search;

        history.pushState(null, null, url.toString());

        // Set a timeout
        if (searchTimeout) clearTimeout(searchTimeout);
        searchTimeout = setTimeout(function (_) {
            return updateGrid();
        }, 500);
    }

    function updateGrid() {
        var params = {
            action: 'get_tip_tool_grid_html',
            activeTypes: activeTypes,
            activeThemes: activeThemes,
            searchQuery: searchQuery
        };

        se_postRequest(se_ajax.ajaxurl, params, function (response) {
            response = JSON.parse(response);

            if (!response.err) {
                archiveGrid.innerHTML = response.html;
            } else {
                alert('Oops.. Something went wrong. Please reload the page and try again.');
                return;
            }
        }, function (_) {
            alert('Oops.. Something went wrong. Please reload the page and try again.');
            return;
        });
    }
})();

(function () {
    var archiveEl = document.querySelector('.jsTrainingAdviseArchive');
    var archiveGrid = null;
    var searchTimeout = null;
    var searchQuery = '';

    if (archiveEl) {
        archiveGrid = archiveEl.querySelector('.jsArchiveGrid');

        var materialFilterEl = archiveEl.querySelector('.jsMaterialTypeFilter');
        if (materialFilterEl) {
            var materialSelect = new SeSelect(materialFilterEl, 'material');
            materialSelect.setActiveOptions(activeMaterialTypes);

            materialSelect.addChangeEventListener(function (newOptions) {
                activeMaterialTypes = Object.keys(newOptions);
                updateGrid();
            });
        }

        var workfieldFilterEl = archiveEl.querySelector('.jsWorkfieldFilter');
        if (workfieldFilterEl) {
            var workfieldSelect = new SeSelect(workfieldFilterEl, 'workfield');
            workfieldSelect.setActiveOptions(activeWorkfields);

            workfieldSelect.addChangeEventListener(function (newOptions) {
                activeWorkfields = Object.keys(newOptions);
                updateGrid();
            });
        }

        var themeFilterEl = archiveEl.querySelector('.jsThemeFilter');
        if (themeFilterEl) {
            var themeSelect = new SeSelect(themeFilterEl, 'theme');
            themeSelect.setActiveOptions(activeThemes);

            themeSelect.addChangeEventListener(function (newOptions) {
                activeThemes = Object.keys(newOptions);
                updateGrid();
            });
        }

        var searchFormEl = archiveEl.querySelector('.jsSearchFilter');
        if (searchFormEl) {
            var searchInputEl = searchFormEl.querySelector('input');

            searchFormEl.addEventListener('submit', function (e) {
                e.preventDefault();
                userDidSearch(searchInputEl.value);
            });

            searchInputEl.addEventListener('keyup', function (e) {
                e.preventDefault();
                userDidSearch(searchInputEl.value);
            });
        }
    }

    function userDidSearch(query) {
        searchQuery = query;

        // Update the URL
        var url = new Url();

        if (searchQuery) url.query.search = searchQuery;else delete url.query.search;

        history.pushState(null, null, url.toString());

        // Set a timeout
        if (searchTimeout) clearTimeout(searchTimeout);
        searchTimeout = setTimeout(function (_) {
            return updateGrid();
        }, 500);
    }

    function updateGrid() {
        var params = {
            action: 'get_training_advise_grid_html',
            activeMaterialTypes: activeMaterialTypes,
            activeWorkfields: activeWorkfields,
            activeThemes: activeThemes,
            searchQuery: searchQuery
        };

        se_postRequest(se_ajax.ajaxurl, params, function (response) {
            response = JSON.parse(response);

            if (!response.err) {
                archiveGrid.innerHTML = response.html;
            } else {
                alert('Oops.. Something went wrong. Please reload the page and try again.');
                return;
            }
        }, function (_) {
            alert('Oops.. Something went wrong. Please reload the page and try again.');
            return;
        });
    }
})();

(function () {
    var archiveEl = document.querySelector('.jsTrainingTeacherArchive');

    var trainingGrid = null;
    var trainersGrid = null;

    var searchTimeout = null;
    var searchQuery = '';

    if (archiveEl) {
        trainingGrid = archiveEl.querySelector('.jsTrainingGrid');
        trainersGrid = archiveEl.querySelector('.jsTrainersGrid');

        var teachingTypeFilterEl = archiveEl.querySelector('.jsTeachingTypeFilter');
        if (teachingTypeFilterEl) {
            var teachingTypeSelect = new SeSelect(teachingTypeFilterEl, 'teaching-type');
            teachingTypeSelect.setActiveOptions(activeTeachingTypes);

            teachingTypeSelect.addChangeEventListener(function (newOptions) {
                activeTeachingTypes = Object.keys(newOptions);
                updateGrid();
            });
        }

        var typeFilterEl = archiveEl.querySelector('.jsTypeFilter');
        if (typeFilterEl) {
            var typeSelect = new SeSelect(typeFilterEl, 'education-type');
            typeSelect.setActiveOptions(activeTypes);

            typeSelect.addChangeEventListener(function (newOptions) {
                activeTypes = Object.keys(newOptions);
                updateGrid();
            });
        }

        var themeFilterEl = archiveEl.querySelector('.jsThemeFilter');
        if (themeFilterEl) {
            var themeSelect = new SeSelect(themeFilterEl, 'theme');
            themeSelect.setActiveOptions(activeThemes);

            themeSelect.addChangeEventListener(function (newOptions) {
                activeThemes = Object.keys(newOptions);
                updateGrid();
            });
        }

        var regionFilterEl = archiveEl.querySelector('.jsRegionFilter');
        if (regionFilterEl) {
            var regionSelect = new SeSelect(regionFilterEl, 'region');
            regionSelect.setActiveOptions(activeRegions);

            regionSelect.addChangeEventListener(function (newOptions) {
                activeRegions = Object.keys(newOptions);
                updateGrid();
            });
        }
    }

    function updateGrid() {

        // trainingGrid
        // trainersGrid

        var params = {
            action: 'get_teachers_trainers_grid_html',
            activeTeachingTypes: activeTeachingTypes,
            activeTypes: activeTypes,
            activeThemes: activeThemes,
            activeRegions: activeRegions,
            searchQuery: searchQuery
        };

        se_postRequest(se_ajax.ajaxurl, params, function (response) {
            response = JSON.parse(response);

            if (!response.err) {
                trainingGrid.innerHTML = response.html_trainingen;
                trainersGrid.innerHTML = response.html_teachers;
            } else {
                alert('Oops.. Something went wrong. Please reload the page and try again.');
                return;
            }
        }, function (_) {
            alert('Oops.. Something went wrong. Please reload the page and try again.');
            return;
        });
    }
})();

(function () {
    var archiveEl = document.querySelector('.jsTeacherArchive');
    var archiveGrid = null;
    var searchTimeout = null;
    var searchQuery = '';

    if (archiveEl) {
        archiveGrid = archiveEl.querySelector('.jsArchiveGrid');

        var teachingTypeFilterEl = archiveEl.querySelector('.jsTeachingTypeFilter');
        if (teachingTypeFilterEl) {
            var teachingTypeSelect = new SeSelect(teachingTypeFilterEl, 'teaching-type');
            teachingTypeSelect.setActiveOptions(activeTeachingTypes);

            teachingTypeSelect.addChangeEventListener(function (newOptions) {
                activeTeachingTypes = Object.keys(newOptions);
                updateGrid();
            });
        }

        var typeFilterEl = archiveEl.querySelector('.jsTypeFilter');
        if (typeFilterEl) {
            var typeSelect = new SeSelect(typeFilterEl, 'education-type');
            typeSelect.setActiveOptions(activeTypes);

            typeSelect.addChangeEventListener(function (newOptions) {
                activeTypes = Object.keys(newOptions);
                updateGrid();
            });
        }

        var themeFilterEl = archiveEl.querySelector('.jsThemeFilter');
        if (themeFilterEl) {
            var themeSelect = new SeSelect(themeFilterEl, 'theme');
            themeSelect.setActiveOptions(activeThemes);

            themeSelect.addChangeEventListener(function (newOptions) {
                activeThemes = Object.keys(newOptions);
                updateGrid();
            });
        }

        var regionFilterEl = archiveEl.querySelector('.jsRegionFilter');
        if (regionFilterEl) {
            var regionSelect = new SeSelect(regionFilterEl, 'region');
            regionSelect.setActiveOptions(activeRegions);

            regionSelect.addChangeEventListener(function (newOptions) {
                activeRegions = Object.keys(newOptions);
                updateGrid();
            });
        }

        var searchFormEl = archiveEl.querySelector('.jsSearchFilter');
        if (searchFormEl) {
            var searchInputEl = searchFormEl.querySelector('input');

            searchFormEl.addEventListener('submit', function (e) {
                e.preventDefault();
                userDidSearch(searchInputEl.value);
            });

            searchInputEl.addEventListener('keyup', function (e) {
                e.preventDefault();
                userDidSearch(searchInputEl.value);
            });
        }
    }

    function userDidSearch(query) {
        searchQuery = query;

        // Update the URL
        var url = new Url();

        if (searchQuery) url.query.search = searchQuery;else delete url.query.search;

        history.pushState(null, null, url.toString());

        // Set a timeout
        if (searchTimeout) clearTimeout(searchTimeout);
        searchTimeout = setTimeout(function (_) {
            return updateGrid();
        }, 500);
    }

    function updateGrid() {
        var params = {
            action: 'get_teachers_grid_html',
            activeTeachingTypes: activeTeachingTypes,
            activeTypes: activeTypes,
            activeThemes: activeThemes,
            activeRegions: activeRegions,
            searchQuery: searchQuery
        };

        se_postRequest(se_ajax.ajaxurl, params, function (response) {
            response = JSON.parse(response);

            if (!response.err) {
                archiveGrid.innerHTML = response.html;
            } else {
                alert('Oops.. Something went wrong. Please reload the page and try again.');
                return;
            }
        }, function (_) {
            alert('Oops.. Something went wrong. Please reload the page and try again.');
            return;
        });
    }
})();

(function () {
    var archiveEl = document.querySelector('.jsTrainingArchive');
    var archiveGrid = null;
    var searchTimeout = null;
    var searchQuery = '';

    if (archiveEl) {
        archiveGrid = archiveEl.querySelector('.jsArchiveGrid');

        var teachingTypeFilterEl = archiveEl.querySelector('.jsTeachingTypeFilter');
        if (teachingTypeFilterEl) {
            var teachingTypeSelect = new SeSelect(teachingTypeFilterEl, 'teaching-type');
            teachingTypeSelect.setActiveOptions(activeTeachingTypes);

            teachingTypeSelect.addChangeEventListener(function (newOptions) {
                activeTeachingTypes = Object.keys(newOptions);
                updateGrid();
            });
        }

        var typeFilterEl = archiveEl.querySelector('.jsTypeFilter');
        if (typeFilterEl) {
            var typeSelect = new SeSelect(typeFilterEl, 'education-type');
            typeSelect.setActiveOptions(activeTypes);

            typeSelect.addChangeEventListener(function (newOptions) {
                activeTypes = Object.keys(newOptions);
                updateGrid();
            });
        }

        var themeFilterEl = archiveEl.querySelector('.jsThemeFilter');
        if (themeFilterEl) {
            var themeSelect = new SeSelect(themeFilterEl, 'theme');
            themeSelect.setActiveOptions(activeThemes);

            themeSelect.addChangeEventListener(function (newOptions) {
                activeThemes = Object.keys(newOptions);
                updateGrid();
            });
        }

        var regionFilterEl = archiveEl.querySelector('.jsRegionFilter');
        if (regionFilterEl) {
            var regionSelect = new SeSelect(regionFilterEl, 'region');
            regionSelect.setActiveOptions(activeRegions);

            regionSelect.addChangeEventListener(function (newOptions) {
                activeRegions = Object.keys(newOptions);
                updateGrid();
            });
        }

        var searchFormEl = archiveEl.querySelector('.jsSearchFilter');
        if (searchFormEl) {
            var searchInputEl = searchFormEl.querySelector('input');

            searchFormEl.addEventListener('submit', function (e) {
                e.preventDefault();
                userDidSearch(searchInputEl.value);
            });

            searchInputEl.addEventListener('keyup', function (e) {
                e.preventDefault();
                userDidSearch(searchInputEl.value);
            });
        }
    }

    function userDidSearch(query) {
        searchQuery = query;

        // Update the URL
        var url = new Url();

        if (searchQuery) url.query.search = searchQuery;else delete url.query.search;

        history.pushState(null, null, url.toString());

        // Set a timeout
        if (searchTimeout) clearTimeout(searchTimeout);
        searchTimeout = setTimeout(function (_) {
            return updateGrid();
        }, 500);
    }

    function updateGrid() {
        var params = {
            action: 'get_trainers_grid_html',
            activeTeachingTypes: activeTeachingTypes,
            activeTypes: activeTypes,
            activeThemes: activeThemes,
            activeRegions: activeRegions,
            searchQuery: searchQuery
        };

        se_postRequest(se_ajax.ajaxurl, params, function (response) {
            response = JSON.parse(response);

            if (!response.err) {
                archiveGrid.innerHTML = response.html;
            } else {
                alert('Oops.. Something went wrong. Please reload the page and try again.');
                return;
            }
        }, function (_) {
            alert('Oops.. Something went wrong. Please reload the page and try again.');
            return;
        });
    }
})();

(function () {
    var archiveEl = document.querySelector('.jsImageVideoArchive');
    var archiveGrid = null;
    var searchTimeout = null;
    var searchQuery = '';

    if (archiveEl) {
        archiveGrid = archiveEl.querySelector('.jsArchiveGrid');

        var typeFilterEl = archiveEl.querySelector('.jsTypeFilter');
        if (typeFilterEl) {
            var typeSelect = new SeSelect(typeFilterEl, 'type');
            typeSelect.setActiveOptions(activeTypes);

            typeSelect.addChangeEventListener(function (newOptions) {
                activeTypes = Object.keys(newOptions);
                updateGrid();
            });
        }

        var themeFilterEl = archiveEl.querySelector('.jsThemeFilter');
        if (themeFilterEl) {
            var themeSelect = new SeSelect(themeFilterEl, 'theme');
            themeSelect.setActiveOptions(activeThemes);

            themeSelect.addChangeEventListener(function (newOptions) {
                activeThemes = Object.keys(newOptions);
                updateGrid();
            });
        }

        var type2FilterEl = archiveEl.querySelector('.jsType2Filter');
        if (type2FilterEl) {
            var type2Select = new SeSelect(type2FilterEl, 'offer-type');
            type2Select.setActiveOptions(activeType2Types);

            type2Select.addChangeEventListener(function (newOptions) {
                activeType2Types = Object.keys(newOptions);
                updateGrid();
            });
        }

        var languageFilterEl = archiveEl.querySelector('.jsLanguageFilter');
        if (languageFilterEl) {
            var _type2Select = new SeSelect(languageFilterEl, 'language');
            _type2Select.setActiveOptions(activeLanguages);

            _type2Select.addChangeEventListener(function (newOptions) {
                activeLanguages = Object.keys(newOptions);
                updateGrid();
            });
        }

        var searchFormEl = archiveEl.querySelector('.jsSearchFilter');
        if (searchFormEl) {
            var searchInputEl = searchFormEl.querySelector('input');

            searchFormEl.addEventListener('submit', function (e) {
                e.preventDefault();
                userDidSearch(searchInputEl.value);
            });

            searchInputEl.addEventListener('keyup', function (e) {
                e.preventDefault();
                userDidSearch(searchInputEl.value);
            });
        }
    }

    function userDidSearch(query) {
        searchQuery = query;

        // Update the URL
        var url = new Url();

        if (searchQuery) url.query.search = searchQuery;else delete url.query.search;

        history.pushState(null, null, url.toString());

        // Set a timeout
        if (searchTimeout) clearTimeout(searchTimeout);
        searchTimeout = setTimeout(function (_) {
            return updateGrid();
        }, 500);
    }

    function updateGrid() {
        var params = {
            action: 'get_image_video_grid_html',
            activeTypes: activeTypes,
            activeThemes: activeThemes,
            activeType2Types: activeType2Types,
            activeLanguages: activeLanguages,
            searchQuery: searchQuery
        };

        se_postRequest(se_ajax.ajaxurl, params, function (response) {
            response = JSON.parse(response);

            if (!response.err) {
                archiveGrid.innerHTML = response.html;
            } else {
                alert('Oops.. Something went wrong. Please reload the page and try again.');
                return;
            }
        }, function (_) {
            alert('Oops.. Something went wrong. Please reload the page and try again.');
            return;
        });
    }
})();

(function () {
    var archiveEl = document.querySelector('.jsMatTrainArchive');
    var archiveGrid = null;
    // let searchTimeout = null;
    // let searchQuery = '';

    if (archiveEl) {
        archiveGrid = archiveEl.querySelector('.jsArchiveGrid');

        var typeFilterEl = archiveEl.querySelector('.jsTypeFilter');
        if (typeFilterEl) {
            var typeSelect = new SeSelect(typeFilterEl, 'type');
            typeSelect.setActiveOptions(activeTypes);

            typeSelect.addChangeEventListener(function (newOptions) {
                activeTypes = Object.keys(newOptions);
                updateGrid();
            });
        }

        var themeFilterEl = archiveEl.querySelector('.jsThemeFilter');
        if (themeFilterEl) {
            var themeSelect = new SeSelect(themeFilterEl, 'theme');
            themeSelect.setActiveOptions(activeThemes);

            themeSelect.addChangeEventListener(function (newOptions) {
                activeThemes = Object.keys(newOptions);
                updateGrid();
            });
        }

        var type2FilterEl = archiveEl.querySelector('.jsType2Filter');
        if (type2FilterEl) {
            var type2Select = new SeSelect(type2FilterEl, 'offer-type');
            type2Select.setActiveOptions(activeType2Types);

            type2Select.addChangeEventListener(function (newOptions) {
                activeType2Types = Object.keys(newOptions);
                updateGrid();
            });
        }

        // const languageFilterEl = archiveEl.querySelector('.jsLanguageFilter');
        // if (languageFilterEl) {
        //     const type2Select = new SeSelect(languageFilterEl, 'language');
        //     type2Select.setActiveOptions(activeLanguages);

        //     type2Select.addChangeEventListener(newOptions => {
        //         activeLanguages = Object.keys(newOptions);
        //         updateGrid();
        //     });
        // }

        // const searchFormEl = archiveEl.querySelector('.jsSearchFilter');
        // if (searchFormEl) {
        //     const searchInputEl = searchFormEl.querySelector('input');

        //     searchFormEl.addEventListener('submit', e => {
        //         e.preventDefault();
        //         userDidSearch(searchInputEl.value);
        //     });

        //     searchInputEl.addEventListener('keyup', e => {
        //         e.preventDefault();
        //         userDidSearch(searchInputEl.value);
        //     });
        // }
    }

    // function userDidSearch(query) {
    //     searchQuery = query;

    //     // Update the URL
    //     const url = new Url;

    //     if (searchQuery) url.query.search = searchQuery;
    //     else delete url.query.search;

    //     history.pushState(null, null, url.toString());

    //     // Set a timeout
    //     if (searchTimeout) clearTimeout(searchTimeout);
    //     searchTimeout = setTimeout(_ => updateGrid(), 500);
    // }

    function updateGrid() {
        var params = {
            action: 'get_mat_train_grid_html',
            activeTypes: activeTypes,
            activeThemes: activeThemes,
            activeType2Types: activeType2Types
            // activeLanguages,
            // searchQuery
        };

        se_postRequest(se_ajax.ajaxurl, params, function (response) {
            response = JSON.parse(response);

            if (!response.err) {
                archiveGrid.innerHTML = response.html;
            } else {
                alert('Oops.. Something went wrong. Please reload the page and try again.');
                return;
            }
        }, function (_) {
            alert('Oops.. Something went wrong. Please reload the page and try again.');
            return;
        });
    }
})();

(function () {
    var archiveEl = document.querySelector('.jsKnowledgeArchive');
    var archiveGrid = null;
    var searchTimeout = null;
    var searchQuery = '';

    if (archiveEl) {
        archiveGrid = archiveEl.querySelector('.jsArchiveGrid');

        var typeFilterEl = archiveEl.querySelector('.jsTypeFilter');
        if (typeFilterEl) {
            var typeSelect = new SeSelect(typeFilterEl, 'type');
            typeSelect.setActiveOptions(activeTypes);

            typeSelect.addChangeEventListener(function (newOptions) {
                activeTypes = Object.keys(newOptions);
                updateGrid();
            });
        }

        var themeFilterEl = archiveEl.querySelector('.jsThemeFilter');
        if (themeFilterEl) {
            var themeSelect = new SeSelect(themeFilterEl, 'theme');
            themeSelect.setActiveOptions(activeThemes);

            themeSelect.addChangeEventListener(function (newOptions) {
                activeThemes = Object.keys(newOptions);
                updateGrid();
            });
        }

        var type2FilterEl = archiveEl.querySelector('.jsType2Filter');
        if (type2FilterEl) {
            var type2Select = new SeSelect(type2FilterEl, 'offer-type');
            type2Select.setActiveOptions(activeType2Types);

            type2Select.addChangeEventListener(function (newOptions) {
                activeType2Types = Object.keys(newOptions);
                updateGrid();
            });
        }

        var languageFilterEl = archiveEl.querySelector('.jsLanguageFilter');
        if (languageFilterEl) {
            var _type2Select2 = new SeSelect(languageFilterEl, 'language');
            _type2Select2.setActiveOptions(activeLanguages);

            _type2Select2.addChangeEventListener(function (newOptions) {
                activeLanguages = Object.keys(newOptions);
                updateGrid();
            });
        }

        var searchFormEl = archiveEl.querySelector('.jsSearchFilter');
        if (searchFormEl) {
            var searchInputEl = searchFormEl.querySelector('input');

            searchFormEl.addEventListener('submit', function (e) {
                e.preventDefault();
                userDidSearch(searchInputEl.value);
            });

            searchInputEl.addEventListener('keyup', function (e) {
                e.preventDefault();
                userDidSearch(searchInputEl.value);
            });
        }
    }

    function userDidSearch(query) {
        searchQuery = query;

        // Update the URL
        var url = new Url();

        if (searchQuery) url.query.search = searchQuery;else delete url.query.search;

        history.pushState(null, null, url.toString());

        // Set a timeout
        if (searchTimeout) clearTimeout(searchTimeout);
        searchTimeout = setTimeout(function (_) {
            return updateGrid();
        }, 500);
    }

    function updateGrid() {
        var params = {
            action: 'get_knowledge_grid_html',
            activeTypes: activeTypes,
            activeThemes: activeThemes,
            activeType2Types: activeType2Types,
            activeLanguages: activeLanguages,
            searchQuery: searchQuery
        };

        se_postRequest(se_ajax.ajaxurl, params, function (response) {
            response = JSON.parse(response);

            if (!response.err) {
                archiveGrid.innerHTML = response.html;
            } else {
                alert('Oops.. Something went wrong. Please reload the page and try again.');
                return;
            }
        }, function (_) {
            alert('Oops.. Something went wrong. Please reload the page and try again.');
            return;
        });
    }
})();

function FAQArchive(el) {
    var _this50 = this;

    this.el = el;
    this.searchInputEl = this.el.querySelector('.jsSearchInput');
    this.sectionEls = this.el.querySelectorAll('.jsSection');
    this.questionEls = this.el.querySelectorAll('.jsQuestion');
    this.sectionTriggerWrapperEl = this.el.querySelector('.jsSectionTriggerWrapper');

    // Add event listeners
    this.searchInputEl.addEventListener('keyup', function (_) {
        return _this50.filterResults();
    });
    window.addEventListener('scroll', function (_) {
        return _this50.setActiveSection();
    });

    this.sectionTriggerWrapperEl.addEventListener('click', function (e) {
        if (e.target.classList.contains('jsSectionTrigger')) {
            var section = _this50.el.querySelector('.jsSection[data-section-slug="' + e.target.dataset.sectionSlug + '"]');
            vanillaSmoothie.scrollTo(section.getBoundingClientRect().y + window.scrollY - 50, { duration: 500, easing: 'easeInOutQuad' });
        }
    });

    this.setActiveSection();
}

FAQArchive.prototype.filterResults = function () {
    if (this.searchInputEl.value === '') {
        for (var i = 0; i < this.questionEls.length; i++) {
            this.questionEls[i].classList.remove('hidden');
        }
    } else {
        for (var _i = 0; _i < this.questionEls.length; _i++) {
            if (this.questionEls[_i].dataset.index.toLowerCase().indexOf(this.searchInputEl.value.toLowerCase) > -1) this.questionEls[_i].classList.remove('hidden');else this.questionEls[_i].classList.add('hidden');
        }
    }
};

FAQArchive.prototype.setActiveSection = function () {
    var triggerPoint = window.scrollY + window.innerHeight * 0.2;

    for (var i = 0; i < this.sectionEls.length; i++) {
        var section = this.sectionEls[i];
        var bounds = section.getBoundingClientRect();
        var sectionTrigger = this.el.querySelector('.jsSectionTrigger[data-section-slug="' + section.dataset.sectionSlug + '"]');

        if (bounds.y + window.scrollY <= triggerPoint && bounds.y + window.scrollY + bounds.height >= triggerPoint) sectionTrigger.classList.add('active');else sectionTrigger.classList.remove('active');
    }
};

(function () {
    var faqArchiveEl = document.querySelector('.jsFaqArchive');
    if (faqArchiveEl) new FAQArchive(faqArchiveEl);
})();

function SubjectArchive(el) {
    var _this51 = this;

    this.el = el;
    // this.resetBtnEl = this.el.querySelector('.jsSubjectArchiveResetBtn');
    this.letterWrapperEl = this.el.querySelector('.jsSubjectArchiveLetters');
    this.subjectWrapperEl = this.el.querySelector('.jsSubjectArchiveSubjects');
    this.letters = this.letterWrapperEl.querySelectorAll('button');
    this.subjects = this.subjectWrapperEl.querySelectorAll('.jsSubjectArchiveSubject');
    this.letterLists = this.subjectWrapperEl.querySelectorAll('.jsSubjectArchiveLetterList');
    this.imgEl = this.el.querySelector('.jsSubjectArchiveImg');
    this.imgLetterEl = this.imgEl.querySelector('span');
    this.searchInput = this.el.querySelector('.jsSearchInput');

    this.letterWrapperEl.addEventListener('click', function (e) {
        if (e.target.tagName.toLowerCase() === 'button') _this51.activateLetter(e.target.dataset.letter, false);
    });

    this.searchInput.addEventListener('keyup', function (e) {
        _this51.search(_this51.searchInput.value);
    });

    this.activateFirstLetter();
}

SubjectArchive.prototype.activateFirstLetter = function () {
    // Activate the first available letter, if any
    var firstEnabledLetter = this.letterWrapperEl.querySelector('button:not(:disabled)');
    if (firstEnabledLetter) this.activateLetter(firstEnabledLetter.dataset.letter, true);
};

SubjectArchive.prototype.activateLetter = function (letter) {
    this.subjectWrapperEl.classList.remove('search');

    this.imgLetterEl.innerHTML = letter;
    this.searchInput.value = '';

    // Activate the letter trigger
    for (var i = 0; i < this.letters.length; i++) {
        if (this.letters[i].dataset.letter === letter) this.letters[i].classList.add('active');else this.letters[i].classList.remove('active');
    }

    // Show the correct letter list
    for (var _i2 = 0; _i2 < this.letterLists.length; _i2++) {
        if (this.letterLists[_i2].dataset.letter === letter) this.letterLists[_i2].classList.remove('hidden');else this.letterLists[_i2].classList.add('hidden');
    }
};

SubjectArchive.prototype.search = function (query) {
    this.reset();

    query = query.toLowerCase();

    if (query !== '') {
        this.subjectWrapperEl.classList.add('search');

        for (var i = 0; i < this.subjects.length; i++) {
            if (this.subjects[i].dataset.title.toLowerCase().indexOf(query) === -1) {
                this.subjects[i].classList.add('hidden');
            }
        }
    }

    // Hide all letter lists that don't have any active subjects and show all others
    for (var _i3 = 0; _i3 < this.letterLists.length; _i3++) {
        var activeSubjects = this.letterLists[_i3].querySelectorAll('.jsSubjectArchiveSubject:not(.hidden)');
        if (activeSubjects.length === 0) this.letterLists[_i3].classList.add('hidden');else this.letterLists[_i3].classList.remove('hidden');
    }
};

SubjectArchive.prototype.reset = function () {
    this.imgLetterEl.innerHTML = '';
    this.subjectWrapperEl.classList.add('search');

    for (var i = 0; i < this.letters.length; i++) {
        this.letters[i].classList.remove('active');
    }for (var _i4 = 0; _i4 < this.subjects.length; _i4++) {
        this.subjects[_i4].classList.remove('hidden');
    }
};

(function () {
    var subjectArchiveEl = document.querySelector('.jsSubjectArchive');
    if (subjectArchiveEl) new SubjectArchive(subjectArchiveEl);
})();

(function () {
    var singleProduct = document.querySelector('.jsSingleProduct');

    if (singleProduct) {
        var productImages = singleProduct.querySelector('.jsProductImages');
        new Flickity(productImages, {
            adaptiveHeight: true,
            prevNextButtons: true,
            pageDots: true
        });
    }
})();

(function () {
    var textPageEl = document.querySelector('.jsTextPage');

    if (textPageEl) {
        var anchorListEl = textPageEl.querySelector('.jsAnchorList');

        if (anchorListEl) {
            var setActiveSection = function setActiveSection() {
                var triggerPoint = window.scrollY + window.innerHeight * 0.2;

                for (var i = 0; i < sectionEls.length; i++) {
                    var section = sectionEls[i];
                    var bounds = section.getBoundingClientRect();
                    var sectionTrigger = textPageEl.querySelector('[data-anchor-slug="' + section.dataset.anchor + '"]');

                    if (bounds.y + window.scrollY <= triggerPoint && bounds.y + window.scrollY + bounds.height >= triggerPoint) sectionTrigger.classList.add('active');else sectionTrigger.classList.remove('active');
                }
            };

            var sectionElsWrapperEl = textPageEl.querySelector('.jsAnchorList');
            var sectionEls = textPageEl.querySelectorAll('[data-anchor]');

            window.addEventListener('scroll', function (_) {
                return setActiveSection();
            });

            sectionElsWrapperEl.addEventListener('click', function (e) {
                if (e.target.classList.contains('jsAnchorTrigger')) {
                    var section = textPageEl.querySelector('[data-anchor="' + e.target.dataset.anchorSlug + '"]');
                    vanillaSmoothie.scrollTo(section.getBoundingClientRect().y + window.scrollY - 50, { duration: 500, easing: 'easeInOutQuad' });
                }
            });

            setActiveSection();

            ;
        }
    }
})();

(function () {
    var headerEl = document.querySelector('.jsImageVideoHeader');

    if (headerEl) {
        headerEl.addEventListener('click', function (e) {
            if (e.target.classList.contains('jsAnchorTrigger') && e.target.dataset.triggerAnchor !== '') {
                e.preventDefault();
                goToTarget(e.target.dataset.triggerAnchor);
            }
        });
    }

    function goToTarget(targetId) {
        var el = document.querySelector('[data-anchor="' + targetId + '"]');

        if (el) {
            var bounds = el.getBoundingClientRect();
            window.scrollTo({ top: window.scrollY + bounds.top - 80, behavior: 'smooth' });
        }
    }
})();